
window.BSDNav = {
  text: function (key, values) {
    var value = (window.BSDNavText || {})[key] || key;
    Object.keys(values || {}).forEach(function (name) { value = value.replace('__' + name + '__', values[name]); });
    return value;
  },
  count: function (d) {
    return new Set((d.groups || []).filter(function (g) { return !g.visual; }).flatMap(function (g) { return g.links.map(function (l) { return l.h; }); })).size;
  },
  escape: function (value) { return String(value || '').replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); },
  range: function (d) {
    var r = d.range, e = window.BSDNav.escape;
    if (!r) return '';
    return '<a class="bsd-nav-range" href="' + e(r.h) + '"><img src="' + e(r.img) + (r.img.indexOf('?') >= 0 ? '&' : '?') + 'width=360" alt="' + e(r.t) + '" width="180" height="120" loading="lazy"><span><small>' + e(window.BSDNav.text('range')) + '</small><b>' + e(r.t) + '</b><span>' + e(r.description) + '</span><strong>' + e(window.BSDNav.text('shop_range')) + ' →</strong></span></a>';
  }
};
/* Consistent, category-specific finish swatches across menu surfaces. */
window.__ATHFinishHTML = function (d, mobile) {
  var values = d.finishStrip || (d.strip === 'fin' ? (window.NAV2.finishStrip || window.NAV2.finishes || []) : []);
  if (!values.length) return '';
  function e(v) { return String(v || '').replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  if (mobile) return '<details class="at-md-group bsd-md-finishes" data-md-optional-group><summary><span>' + e(window.BSDNav.text('finish')) + '</span><b class="bsd-md-plus" aria-hidden="true"></b></summary><div class="bsd-md-finish-grid">' + values.map(function(x) { return '<a href="' + e(x[1]) + '"><i class="at-fsw--' + e(x[2]) + '" aria-hidden="true"></i><span>' + e(x[0]) + '</span></a>'; }).join('') + '</div><a class="bsd-md-finish-all" href="/pages/colours">' + e(window.BSDNav.text('all_finishes')) + ' →</a></details>';
  return '<div class="at-bsd-finish-strip"><span class="at-mg-sl at-finish-heading">Shop by finish</span><div class="at-mg-fins">' +
    values.map(function(x) { return '<a class="at-mg-fin at-fsw--' + e(x[2]) + '" href="' + e(x[1]) + '" aria-label="' + e(x[0]) + '" title="' + e(x[0]) + '"><i></i></a>'; }).join('') +
    '</div><a class="at-mg-allcat" href="/pages/colours">All finishes &rarr;</a></div>';
};

/* Shared, accessible visual options in all menu surfaces. */
function bsdMenuVisual(l) {
  function e(v) { return String(v || '').replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  if (l.visual === 'colour') return '<span class="at-option-visual at-option-visual--colour at-fsw--' + e(l.swatch) + '" aria-hidden="true"></span>';
  if (l.visual === 'size') {
    var form = l.shape === 'bath' ? '<path d="M7 18h42v6c0 8-7 12-14 12H21C14 36 7 32 7 24Z"/><path d="M11 36v4m34-4v4"/>' : '<ellipse cx="28" cy="22" rx="20" ry="10"/><path d="M8 22v5c0 8 40 8 40 0v-5"/>';
    return '<span class="at-option-visual at-option-visual--size" aria-hidden="true"><svg viewBox="0 0 56 56" fill="none" stroke="currentColor" stroke-width="1.6">' + form + '<path d="M8 47h40M8 43v8m40-8v8m-36-7-4 3 4 3m32-6 4 3-4 3"/></svg></span>';
  }
  if (l.visual === 'material') return '<span class="at-option-visual at-option-visual--material" aria-hidden="true"><img src="' + e(l.img + (l.img.indexOf('?') < 0 ? '?' : '&') + 'width=140') + '" alt="" loading="lazy"></span>';
  return '';
}
/* Current category brands, rendered from Shopify's available filter values. */
(function () {
  'use strict';
  var data = {}, node = document.getElementById('atMenuBrands');
  try { data = node ? JSON.parse(node.textContent) : {}; } catch (e) { data = {}; }
  function esc(value) { return String(value || '').replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  var priority = ['Ovia','Fienza','Geberit','Hotwire','Meir','Modern National','Lauxes','Architectural Designer Products (ADP)','ADP','Nero'];
  window.__ATHBrandHTML = function (key) {
    var brands = (data[key] || []).filter(function (b) { return !/\bikon\b/i.test(b.title); });
    if (!brands.length) return '';
    brands.sort(function (a,b) {
      var ai = priority.indexOf(a.title), bi = priority.indexOf(b.title);
      return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi) || a.title.localeCompare(b.title);
    });
    return '<div class="at-menu-brands"><h5>Shop by brand</h5><div class="at-menu-brand-list">' + brands.map(function (brand) {
      return '<a class="at-menu-brand" href="' + esc(brand.url) + '" aria-label="Shop ' + esc(brand.title) + '" title="' + esc(brand.title) + '">' +
        (brand.image ? '<img src="' + esc(brand.image) + '" alt="' + esc(brand.title) + '" width="110" height="36" loading="lazy">' : '<span>' + esc(brand.title) + '</span>') + '</a>';
    }).join('') + '</div></div>';
  };
})();

/* ============================================================
   ATELIER HEADER SYSTEM - behaviour, ported from
   _bsd-home-v5-atelier-harness.html (approved 2026-06-12).
   Self-contained: no dependence on main.js / global.js.
   M1: sticky offset, compact-on-scroll, nav ink bar, search fallback.
   M2: mega panels (data + show/hide + crossfade preview + strips +
       finish tooltip + #mega-<key> deep-link).
   Mega data is hardcoded (Phase A, approved) - same taxonomy as the
   store's real collections. Phase B may move it to atelier-* menus.
   ============================================================ */
(function () {
  'use strict';

  /* ---- product-card touch "hover": JS-driven so it clears on lift ----
     iOS keeps the native :hover STUCK after a touch (the pointer-events trick didn't release
     it), and we gate :hover to pointer devices in CSS. On touch we instead drive a `.is-press`
     class: add it to the card under the finger on touchstart and as the finger drags across
     cards (elementFromPoint), and REMOVE it on lift/cancel. So the lift still plays while you
     drag through cards but vanishes the moment you let go. We never touch pointer-events, so a
     tap's click/navigation is unaffected. Runs before the header bail-out so it works on every
     page (cards aren't header-dependent). */
  if ('ontouchstart' in window) {
    var pcCur = null, pcAF = 0;
    /* stand down while the finish-bloom gesture owns the touch (atelier-finish-bloom.js
       adds .fb-on to <html>) - otherwise the press-lift fights the bloom's focal panel. */
    var fbOn = function () { return document.documentElement.classList.contains('fb-on'); };
    var pcSet = function (card) {
      if (fbOn()) card = null;
      if (card === pcCur) return;
      if (pcCur) pcCur.classList.remove('is-press');
      pcCur = card;
      if (pcCur) pcCur.classList.add('is-press');
    };
    document.addEventListener('touchstart', function (e) {
      pcSet(e.target && e.target.closest ? e.target.closest('.pc') : null);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      var tp = e.touches && e.touches[0]; if (!tp) return;
      var x = tp.clientX, y = tp.clientY;
      if (pcAF) return;
      pcAF = requestAnimationFrame(function () {
        pcAF = 0;
        var el = document.elementFromPoint(x, y);
        pcSet(el && el.closest ? el.closest('.pc') : null);
      });
    }, { passive: true });
    var pcEnd = function () { if (pcAF) { cancelAnimationFrame(pcAF); pcAF = 0; } pcSet(null); };
    document.addEventListener('touchend', pcEnd, { passive: true });
    document.addEventListener('touchcancel', pcEnd, { passive: true });
  }

  var sect = document.querySelector('.section-atelier-header');
  if (!sect) return;
  var hdr = sect.querySelector('.at-hdr');
  var topBar = sect.querySelector('.at-top');

  var CDN = 'https://cdn.shopify.com/s/files/1/0701/6261/2373/files/';
  function $(s, c) { return (c || sect).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || sect).querySelectorAll(s)); }
  function aud(n) { return '$' + n.toLocaleString('en-AU'); }
  function pct(p, c) { return c > p ? Math.round((1 - p / c) * 100) : 0; }

  /* ---- sticky offset: the announcement strip scrolls away, the
     glass header pins. The section wrapper is sticky with a negative
     top equal to the strip's height (measured, so wrapping-safe). */
  var svgEl = sect.querySelector('.at-logo-svg');
  /* --bath-shift: how far to slide ONLY the bath mark from its spot in the lockup to
     the header centre when the header collapses on mobile (the wordmark stays put and
     wipes). The bath now lives in its OWN <svg> element (.at-lk-bath) which we translate
     wholesale, so the shift is a plain px LENGTH (CSS pixels) - no transform-box needed
     and identical on every browser. (A px translate on a <g> would be SVG user-units and
     overshoot on iOS, which is why the old fill-box % existed; an element px translate
     does not have that problem.) */
  function setLogoSwoop() {
    if (!svgEl || window.innerWidth >= 768) { sect.style.removeProperty('--bath-shift'); return; }
    var bathG = svgEl.querySelector('.bath');
    var r = svgEl.getBoundingClientRect();
    if (!bathG || !r.width) return;
    var bb; try { bb = bathG.getBBox(); } catch (e) { return; }
    if (!bb || !bb.width) return;
    var scale = r.width / 1092.7;                         /* screen px per SVG user unit */
    var bathCentre = r.left + (bb.x + bb.width / 2) * scale;
    var deltaPx = window.innerWidth / 2 - bathCentre;     /* CSS px to move the bath right */
    sect.style.setProperty('--bath-shift', deltaPx.toFixed(1) + 'px');
  }
  function setTopOffset() {
    sect.style.setProperty('--at-topbar-h', (topBar ? topBar.offsetHeight : 0) + 'px');
    /* native anchor jumps land below the pinned header */
    document.documentElement.style.scrollPaddingTop = hdr.offsetHeight + 'px';
    setLogoSwoop();
  }
  setTopOffset();
  window.addEventListener('resize', setTopOffset);
  window.addEventListener('load', setTopOffset);

  /* ---- compact-on-scroll (nothing hides - everything tightens).
     Hysteresis: compacting changes the header height (~28px), and the
     browser's scroll anchoring then shifts scrollY by the same amount -
     a single threshold oscillates (grow/shrink flicker near the top).
     The dead zone between the two thresholds is wider than the
     anchoring jump, so the loop can't close. */
  function onScroll() {
    var y = window.scrollY;
    /* mobile collapses far more header height (search row + logo morph), so widen
       the dead zone there to clear the scroll-anchor jump and avoid stick/unstick
       flicker near the threshold. */
    var on = window.innerWidth < 768 ? 110 : 64;
    if (y > on) hdr.classList.add('is-stuck');
    else if (y < 8) hdr.classList.remove('is-stuck');
    /* between the two thresholds: keep whichever state we're in (hysteresis) */
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- sliding red ink bar under the category nav */
  var navWrap = $('.at-nav .at-wrap');
  var navInk = $('.at-nav-ink');
  function inkTo(it) {
    navInk.style.width = Math.max(18, it.offsetWidth - 22) + 'px';
    navInk.style.transform = 'translateX(' + (it.offsetLeft + 11) + 'px)';
    navInk.style.opacity = 1;
  }
  if (navWrap && navInk) {
    navWrap.addEventListener('mouseover', function (e) {
      if (searchIsOpen()) return;
      var it = e.target.closest('.at-nv');
      if (it) inkTo(it);
    });
    navWrap.addEventListener('mouseleave', function () {
      var open = navWrap.querySelector('.at-nv.is-open');
      if (open) inkTo(open);
      else navInk.style.opacity = 0;
    });
    /* arrow keys across the nav for keyboard users (skip any hidden buttons) */
    navWrap.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var items = $$('.at-nv:not(.at-nv-hide)', navWrap);
      var idx = items.indexOf(document.activeElement);
      if (idx < 0) return;
      e.preventDefault();
      items[(idx + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length].focus();
    });
  }

  /* ---- priority nav: as the bar narrows, hide ONLY the right-hand utility
     links when they would actually overflow - Clearance, then Packages, then
     Instant Ship, then All categories last. The eight category buttons are
     NEVER hidden. Fit is measured by summing the visible buttons' real widths,
     NOT scrollWidth (the margin-left:auto on .at-nv--right inflates scrollWidth
     and would make it hide buttons that actually fit). */
  if (navWrap) {
    var navAll = $('#atNavAllCats');
    var navUtils = [], navPastAll = false;
    $$('.at-nv', navWrap).forEach(function (it) {
      if (it === navAll) { navPastAll = true; return; }
      if (navPastAll) navUtils.push(it); /* Instant Ship, Packages, Clearance */
    });
    /* hide order: promo links right-to-left, then All categories last */
    var navHideSeq = navUtils.filter(function (it) { return !it.classList.contains('at-nv--ship'); }).reverse();
    if (navAll) navHideSeq.push(navAll);
    var fitNav = function () {
      if (!navWrap.clientWidth) return; /* nav hidden (<=767px) - leave as-is */
      navHideSeq.forEach(function (it) { it.classList.remove('at-nv-hide'); });
      for (var i = 0; i < navHideSeq.length; i++) {
        /* Neutralise the .at-nv--right auto margin while measuring so scrollWidth
           reflects the REAL packed content width (the auto margin otherwise
           inflates it and reports phantom overflow). >6px slop absorbs sub-pixel
           rounding, so a button that basically fits is never hidden. */
        navWrap.classList.add('at-nav-measuring');
        var overflowing = navWrap.scrollWidth - navWrap.clientWidth > 6;
        navWrap.classList.remove('at-nav-measuring');
        if (!overflowing) break;
        navHideSeq[i].classList.add('at-nv-hide');
      }
    };
    var navRaf;
    var scheduleFit = function () {
      cancelAnimationFrame(navRaf);
      navRaf = requestAnimationFrame(fitNav);
    };
    if ('ResizeObserver' in window) new ResizeObserver(scheduleFit).observe(navWrap);
    else window.addEventListener('resize', scheduleFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    fitNav();
  }

  /* ---- search input: the live palette module (below) owns all key
     handling. Deliberately NOT a form[action="/search"], so the stock
     Algolia autocomplete never binds to it. */
  var spInput = $('#atSearchInput');
  function searchIsOpen() {
    return hdr.classList.contains('has-search-palette') || hdr.classList.contains('is-searching');
  }
  var spalHide = function () {}; /* reassigned by the palette module */
  /* "/" focuses search from anywhere */
  window.addEventListener('keydown', function (e) {
    if (e.key === '/' && spInput && !/input|textarea|select/i.test(document.activeElement.tagName)) {
      e.preventDefault();
      spInput.focus();
    }
  });

  /* ============================ MEGA MENU ============================
     Link entries: [label, path, previewImage?, fitFlag?] - hovering a
     link with an image crossfades the preview window to it. */
  var MEGA = window.NAV2.mega;
  /* Ovia promo flags (v5: chips were trialled in panels and reverted -
     full text lists read better) */
  /* v2 nav: promo flags live in the NAV2 data (assets/atelier-nav-data.js) */

  /* the 13 colour collections: [name, path, css-gradient swatch] */
  /* [label, collection, finish-FAMILY slug]. The slug picks a .at-fsw--<family> gradient
     class (atelier-header.css), which MIRRORS the canonical site-wide .ac-sw--<family>
     set - so these swatches match the rest of the site and can't drift. See the family
     block in atelier-header.css + [[finish-swatch-family-matching]]. */
  /* the two nickels share one collection, pre-filtered by their own colour
     metaobject (warm/cool split applied to the data 2026-07-02) */
  var NICKEL_F = '/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F';
  var FINISHES = window.NAV2.finishes;

  var mega = $('#atMega'), megaScrim = document.getElementById('atMegaScrim');
  var mgImgA = $('#atMgImgA'), mgImgB = $('#atMgImgB');
  var mgTimer = null, mgKey = null, mgFlip = false, mgCur = '';

  function mgPreview(src, fit) {
    if (src === mgCur) return;
    mgCur = src;
    var back = mgFlip ? mgImgA : mgImgB, front = mgFlip ? mgImgB : mgImgA;
    back.src = src;
    back.classList.toggle('fit', !!fit);
    requestAnimationFrame(function () { back.classList.add('on'); front.classList.remove('on'); });
    mgFlip = !mgFlip;
  }
  function mgShow(key, it) {
    if (searchIsOpen()) return;
    var d = MEGA[key];
    if (!d) return;
    /* v2 nav: custom panel types (rail / std / colours / brands) render into
       #atMgCustom via the panels module at the end of this file */
    mega.classList.toggle('at-mega--custom', !!d.ptype);
    if (d.ptype) {
      spalHide();
      if (mgKey !== key) {
        mgKey = key;
        var cEl = document.getElementById('atMgCustom');
        if (cEl && window.__ATHRender) {
          cEl.innerHTML = window.__ATHRender(key, d);
          if (window.__ATHInit) window.__ATHInit(key, d, cEl);
        }
      }
      mega.classList.add('is-open');
      megaScrim.classList.add('on');
      mega.setAttribute('aria-hidden', 'false');
      $$('.at-nv').forEach(function (n) { n.classList.toggle('is-open', n === it); });
      inkTo(it);
      return;
    }
    spalHide();
    if (mgKey !== key) {
      mgKey = key;
      var i = 0;
      $('#atMgLinks').innerHTML = d.groups.map(function (g) {
        return '<div class="at-mg-g' + (g.visual ? ' at-option-group' : '') + '"><h5>' + g.h + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
          g.links.map(function (l) {
            return '<li style="--i:' + (i++) + '"><a class="at-mg-l" href="' + l[1] + '"' +
              (l[2] ? ' data-img="' + l[2] + '" data-fit="' + (l[3] ? 1 : 0) + '"' : '') + '>' + l[0] + '</a></li>';
          }).join('') + '</ul></div>';
      }).join('');
      /* the red Ovia promo row (#atMgPromo) was REMOVED here (Chris 2026-07-13);
         the promo flags in NAV2 data are inert now */
      var f = d.feat, FE = $('#atMgFeat');
      if (f.type === 'prod') {
        var off = pct(f.p, f.c);
        FE.innerHTML = '<span class="at-mg-ft">Top pick</span>' +
          '<a class="at-mgp" href="' + f.h + '">' +
          '<span class="at-mgp-im">' + (off ? '<span class="at-mgp-chip">−' + off + '%</span>' : '') + '<img src="' + CDN + f.i + '" alt="' + f.t + '" loading="lazy"></span>' +
          '<span class="at-mgp-bd"><b>' + f.t + '</b><span class="at-mgp-pr"><span class="at-now">' + aud(f.p) + '</span><span class="at-was">' + aud(f.c) + '</span></span><span class="at-mgp-go">Shop now →</span></span>' +
          '</a>';
      } else {
        FE.innerHTML = '<span class="at-mg-ft">' + f.k + '</span>' +
          '<a class="at-mg-tile" href="' + f.h + '"><img src="' + CDN + f.i + '" alt="" loading="lazy">' +
          '<span>' + (f.tag ? '<i>' + f.tag + '</i>' : '') + '<b>' + f.t + '</b><span class="at-go">' + f.go + '</span></span></a>';
      }
      var S = $('#atMgStrip');
      if (d.strip === 'fin') {
        S.innerHTML = '<span class="at-mg-sl at-finish-heading">Shop by finish</span><div class="at-mg-fins">' +
          FINISHES.map(function (x, j) {
            return '<a class="at-mg-fin at-fsw--' + x[2] + '" href="' + x[1] + '" aria-label="' + x[0] + '"><i></i></a>';
          }).join('') +
          '</div><a class="at-mg-allcat" href="/pages/colours">All colours →</a>';
      } else {
        S.innerHTML = '<span class="at-mg-sl">Quick links</span><div class="at-mg-qk">' +
          '<a href="/collections/instant-ship">Instant Ship</a>' +
          '<a href="/collections/bathroom-packages">Shop Packages</a>' +
          '<a class="hot" href="/collections/clearance">Clearance</a></div>' +
          '<a class="at-mg-allcat" href="' + d.all + '">View all ' + d.t + ' →</a>';
      }
      $('#atMgView').href = d.all;
      $('#atMgCapT').textContent = 'Explore ' + d.t;
      mgPreview(CDN + d.img, false);
      [$('#atMgView'), FE].forEach(function (el) {
        el.style.animation = 'none';
        void el.offsetHeight;
        el.style.animation = '';
      });
    }
    mega.classList.add('is-open');
    megaScrim.classList.add('on');
    mega.setAttribute('aria-hidden', 'false');
    $$('.at-nv').forEach(function (n) { n.classList.toggle('is-open', n === it); });
    inkTo(it);
  }
  function mgHide() {
    mega.classList.remove('is-open');
    megaScrim.classList.remove('on');
    mega.setAttribute('aria-hidden', 'true');
    mgKey = null;
    $$('.at-nv').forEach(function (n) { n.classList.remove('is-open'); });
    navInk.style.opacity = 0;
  }
  $$('.at-nv[data-mega]').forEach(function (it) {
    it.addEventListener('mouseenter', function () {
      clearTimeout(mgTimer);
      if (searchIsOpen()) return;
      mgTimer = setTimeout(function () { mgShow(it.dataset.mega, it); }, 110);
    });
    it.addEventListener('mouseleave', function () {
      clearTimeout(mgTimer);
      mgTimer = setTimeout(mgHide, 260);
    });
    it.addEventListener('focus', function () { mgShow(it.dataset.mega, it); });
  });
  mega.addEventListener('mouseenter', function () { clearTimeout(mgTimer); });
  mega.addEventListener('mouseleave', function () { mgTimer = setTimeout(mgHide, 220); });
  $('#atMgLinks').addEventListener('mouseover', function (e) {
    var a = e.target.closest('[data-img]');
    if (!a) return;
    mgPreview(CDN + a.dataset.img, a.dataset.fit === '1');
  });
  $('#atMgLinks').addEventListener('mouseleave', function () {
    var d = MEGA[mgKey];
    if (d) mgPreview(CDN + d.img, false);
  });
  megaScrim.addEventListener('click', mgHide);

  /* Esc closes everything open (mdClose/xdClose are hoisted from the
     drawer module below; palette joins in M4) */
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { mgHide(); spalHide(); mdClose(); xdClose(); }
  });

  /* ---- finish-dot tooltip: shared fixed node on <body> (scroll
     containers clip ::after pseudo-tooltips) */
  var finTip = document.createElement('div');
  finTip.className = 'at-fin-tip';
  document.body.appendChild(finTip);
  document.addEventListener('mouseover', function (e) {
    var f = e.target.closest('.at-mg-fin');
    if (!f) { finTip.classList.remove('on'); return; }
    var r = f.getBoundingClientRect();
    finTip.textContent = f.getAttribute('aria-label') || '';
    finTip.style.left = r.left + r.width / 2 + 'px';
    finTip.style.top = r.top - 30 + 'px';
    finTip.classList.add('on');
  });

  /* deep-link/debug: open a panel via #mega-<key> (e.g. #mega-tapware) */
  var mgHash = location.hash.match(/^#mega-(\w+)/);
  if (mgHash && MEGA[mgHash[1]]) {
    var hashIt = sect.querySelector('.at-nv[data-mega="' + mgHash[1] + '"]');
    if (hashIt) setTimeout(function () { mgShow(mgHash[1], hashIt); }, 400);
  }

  /* ============================ DRAWERS (M3) ============================ */
  var mdrawer = document.getElementById('atMdrawer');
  var xdrawer = document.getElementById('atXdrawer');
  var dscrim = document.getElementById('atDscrim');
  /* portal to <body>: backdrop-filter needs a clean backdrop context,
     and the drawers should not live inside the sticky header wrapper */
  [dscrim, mdrawer, xdrawer].forEach(function (el) { document.body.appendChild(el); });
  var xdLeft = document.getElementById('atXdLeft');
  var xdRight = document.getElementById('atXdRight');

  /* the page stays scrollable (scrollbar stays put - no layout jump);
     opening a drawer blurs the page roots via this body class */
  function mdOpen() {
    mdTrigger = document.activeElement;
    buildMdBody(); /* deferred build - see buildMdBody */
    mdReset();
    mdrawer.inert = false;
    mdrawer.classList.add('on');
    document.body.classList.add('bsd-mobile-menu-open');
    mdSetHeader();
    requestAnimationFrame(mdMore);
    mdrawer.setAttribute('aria-hidden', 'false');
    document.getElementById('atMdX').focus({preventScroll:true});
    dscrim.classList.add('on');
    document.body.classList.add('at-drawer-open');
  }
  function mdClose() {
    var wasOpen = mdrawer.classList.contains('on');
    mdrawer.classList.remove('on');
    mdrawer.inert = true;
    document.body.classList.remove('bsd-mobile-menu-open');
    mdrawer.setAttribute('aria-hidden', 'true');
    if (wasOpen && mdTrigger && typeof mdTrigger.focus === 'function') mdTrigger.focus({preventScroll:true});
    if (!xdrawer.classList.contains('on')) {
      dscrim.classList.remove('on');
      document.body.classList.remove('at-drawer-open');
    }
  }

  /* mobile drawer body: Ovia promo, department accordions from MEGA,
     extra departments, finish dots, quick links */
  var MD_EXTRA = window.NAV2.mdExtra;
  var chevR = '<svg viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg>';
  /* v2 drawers: CDN-resized image URL + the shared thumb-row markup
     (mirrors the panels module - floating cutout, invisible spacer when none) */
  function dwUrl(u, w) {
    if (!u) return '';
    if (!/^https?:/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }
  function dwThumb(l, px) {
    /* second img = the silhouette ground shadow (same cached URL; styled by
       the approved micro-interactions block in atelier-header.css; hidden
       in the touch-first mobile drawer) */
    /* loading="lazy" is LOAD-BEARING (warm-up v2, 2026-07-17): the mobile
       drawer body is built at init on every page, and eager imgs here fetched
       ~92 cutouts per cold load with the drawer closed. Lazy imgs in the
       hidden drawer stay unfetched; the burger-intent warm-up (width 140,
       matching dwUrl's default) has them cached before they're seen. */
    if (l.visual) return bsdMenuVisual(l);
    var u = dwUrl(l.img, px || 140);
    return l.cut
      ? '<span class="at-th at-th--cut"><img src="' + u + '" alt="" loading="lazy"><img class="at-th-sh" src="' + u + '" alt="" loading="lazy" aria-hidden="true"></span>'
      : (l.img ? '<span class="at-th"><img src="' + u + '" alt="" loading="lazy"></span>' : '<span class="at-th at-th--cut at-th--none"></span>');
  }
  function dwCatThumb(d) {
    return '<span class="at-dw-cth">' + (d.img ? '<img src="' + dwUrl(d.img, 180) + '" alt="" width="56" height="56" style="object-fit:' + (d.imageFit || 'cover') + ';object-position:' + (d.imagePosition || 'center') + '" loading="lazy">' : '') + '</span>'; /* 120 = the warm-up's railImg variant (was 100 - unwarmed) */
  }
  /* "Not sure what to pick?" hub row for the two drawers - same Option A card
     as the mega panes (that guideHTML lives in the panels module below). */
  var DW_GD_IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>';
  function gdRow(d, cls) {
    return d.hub
      ? '<a class="at-gd ' + cls + '" href="' + d.hub + '"><i class="at-gd-ic">' + DW_GD_IC + '</i>' +
        '<span class="at-gd-lb"><b>Not sure what to pick?</b><small class="at-gd-hub">' + d.guideT + '</small></span>' +
        '<span class="at-gd-btn">Start here</span></a>'
      : '';
  }
  /* Account lives here on phones (.at-act--sec, hidden from the header row below 768px).
     Wishlist is NOT here anymore - it's a primary header icon on mobile too. */
  var acctRow =
    '<div class="at-md-acct">' +
      '<a class="at-md-ai" href="/account"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></svg>Account</a>' +
    '</div>';
  var mdBodyBuilt = false;
  var mdHomeHTML = "", mdActiveCategory = null, mdHomeScroll = 0, mdTrigger = null;
  function buildMdBody() {
    /* built on FIRST OPEN, not at init (warm-up v2, 2026-07-17): init-time
       markup made every cold load fetch ~90 drawer cutouts. loading="lazy"
       cannot save an off-canvas drawer - translateX(-100%) still sits inside
       Chromium's lazy-load margin, so the imgs fetched anyway. No markup
       until open = no fetches; the burger-intent warm-up has the shared
       width-140 variants cached before the accordion is expanded. */
    if (mdBodyBuilt) return;
    mdBodyBuilt = true;
    document.getElementById('atMdBody').innerHTML =
    acctRow +
    '<div class="at-md-sec">Categories</div>' +
    ['tapware', 'vanities', 'toilets', 'baths', 'basins', 'showers', 'accessories', 'heating', 'mirrors', 'screens', 'wastes', 'care', 'kitchen', 'laundry', 'doors', 'commercial', 'outdoor'].filter(function (k) { return window.NAV2.drawerCats[k]; }).map(function (k) {
      var d = window.NAV2.drawerCats[k];
      return '<div class="at-md-cat" data-k="' + k + '">' +
        '<button class="at-md-q at-md-q--forward" type="button" aria-label="Browse ' + mdEscape(d.t) + '">' + dwCatThumb(d) + '<span class="at-dw-qt">' + mdEscape(k === 'mirrors' ? 'Mirrors and Cabinets' : d.t) + '<small>' + mdEscape(window.BSDNav.text('collection_count', {count: window.BSDNav.count(d)})) + '</small></span><span class="bsd-md-arrow"><span>' + mdEscape(window.BSDNav.text('browse')) + '</span>' + chevR + '</span></button></div>';
    }).join('') +
    (MD_EXTRA.length ? '<div class="at-md-sec">More categories</div>' : '') +
    MD_EXTRA.map(function (l) { return '<a class="at-md-link" href="' + l[1] + '">' + l[0] + chevR + '</a>'; }).join('') +
    '<a class="at-md-link" href="/collections">All Categories' + chevR + '</a>' +
    '<div class="at-md-sec at-finish-heading">Shop by finish</div>' +
    '<div class="at-md-fins">' + FINISHES.map(function (x) {
      return '<a class="at-md-fin" href="' + x[1] + '"><span class="at-md-fsw at-fsw--' + x[2] + '"></span>' + x[0] + '</a>';
    }).join('') + '</div>' +
    '<a class="at-md-link" href="/pages/colours">Find your finish' + chevR + '</a>' +
    '<div class="at-md-sec">Quick links</div>' +
    '<a class="at-md-link" href="/collections/instant-ship">Instant Ship' + chevR + '</a>' +
    '<a class="at-md-link" href="/collections/bathroom-packages">Shop Packages' + chevR + '</a>' +
    '<a class="at-md-link hot" href="/collections/clearance">Clearance' + chevR + '</a>' +
    '<a class="at-md-link" href="/pages/brands">Shop by Brands' + chevR + '</a>' +
    '<a class="at-md-link" href="/pages/brochures">Brochures' + chevR + '</a>';
    mdHomeHTML = document.getElementById('atMdBody').innerHTML;
  }

  function mdEscape(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c];
    });
  }
  function mdLink(l) {
    return '<a class="at-md-l at-md-l--v2' + (l.visual ? ' at-option' : (l.compact ? ' at-md-l--compact' : '')) + '" href="' + mdEscape(l.h) + '">' +
      (l.compact ? '' : dwThumb(l)) + '<span class="at-lb"><span class="at-lt">' + mdEscape(l.l) + '</span>' +
      (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') + '</span><span class="bsd-md-link-arrow" aria-hidden="true">→</span></a>';
  }
  function mdCategoryHTML(k) {
    var d = window.NAV2.drawerCats[k];
    if (!d) return '';
    var text = window.BSDNav.text, brands = window.__ATHBrandHTML(k);
    return '<section class="at-md-detail" aria-labelledby="atMdCategoryTitle">' +
      '<div class="at-md-detail-head"><p class="bsd-md-breadcrumb">' + mdEscape(text('menu')) + ' / ' + mdEscape(d.t) + '</p>' +
      '<h2 id="atMdCategoryTitle" tabindex="-1">' + mdEscape(d.t) + '</h2></div>' +
      '<a class="at-md-all at-md-all--top" href="' + mdEscape(d.all) + '">' + mdEscape(text('view_all', {category:d.t})) + ' →</a>' +
      d.groups.map(function (g) {
        return '<details class="at-md-group" data-md-collection-group open><summary><span>' + mdEscape(g.h) + '</span><small>' + mdEscape(text(g.visual ? 'option_count' : 'collection_count', {count:g.links.length})) + '</small><b class="bsd-md-plus" aria-hidden="true"></b></summary><div class="at-md-sub-links' + (g.visual ? ' at-option-grid' : '') + '">' + g.links.map(mdLink).join('') + '</div></details>';
      }).join('') +
      (brands ? '<details class="at-md-group" data-md-optional-group><summary><span>' + mdEscape(text('brands')) + '</span><b class="bsd-md-plus" aria-hidden="true"></b></summary><div class="at-md-sub-links at-md-brands">' + brands + '</div></details>' : '') +
      window.__ATHFinishHTML(d, true) + gdRow(d, 'at-md-guide') + window.BSDNav.range(d) + '</section>';
  }
  function mdShowCategory(k) {
    var body = document.getElementById('atMdBody');
    if (!window.NAV2.drawerCats[k]) return;
    mdHomeScroll = body.scrollTop;
    mdActiveCategory = k;
    body.innerHTML = mdCategoryHTML(k);
    body.scrollTop = 0;
    mdSetHeader();
    body.querySelector('#atMdCategoryTitle').focus({preventScroll:true});
    requestAnimationFrame(mdMore);
  }
  function mdShowHome() {
    var body = document.getElementById('atMdBody'), last = mdActiveCategory;
    body.innerHTML = mdHomeHTML;
    mdActiveCategory = null;
    body.scrollTop = mdHomeScroll;
    var button = body.querySelector('[data-k="' + last + '"] .at-md-q');
    if (button) button.focus({preventScroll:true});
    mdSetHeader();
    requestAnimationFrame(mdMore);
  }
  document.getElementById('atMdBody').addEventListener('click', function (e) {
    if (e.target.closest('[data-md-back]')) { mdShowHome(); return; }
    var q = e.target.closest('.at-md-q');
    if (q) mdShowCategory(q.parentNode.dataset.k);
    var expand = e.target.closest('[data-md-expand]');
    if (expand) {
      var open = expand.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('#atMdBody [data-md-collection-group]').forEach(function (group) { group.open = open; });
      expand.setAttribute('aria-expanded', String(open));
      expand.textContent = window.BSDNav.text(open ? 'hide_groups' : 'show_groups') + (open ? ' −' : ' +');
      requestAnimationFrame(mdMore);
    }
    if (e.target.closest('a[href]')) mdClose();
  });
  function mdSetHeader() {
    document.getElementById('atMdBack').hidden = !mdActiveCategory;
    document.getElementById('atMdHomeTitle').hidden = !!mdActiveCategory;
  }
  function mdSyncExpand() {
    var body=document.getElementById('atMdBody'), button=body.querySelector('[data-md-expand]');
    if(!button)return;
    var groups=Array.from(body.querySelectorAll('[data-md-collection-group]')), all=groups.length>0 && groups.every(function(g){return g.open;});
    button.setAttribute('aria-expanded',String(all));
    button.textContent=window.BSDNav.text(all?'hide_groups':'show_groups')+(all?' −':' +');
  }
  function mdMore() {
    var body = document.getElementById('atMdBody'), more = document.getElementById('atMdMore');
    more.hidden = body.scrollHeight - body.scrollTop - body.clientHeight < 24;
  }
  function mdReset() {
    var body = document.getElementById('atMdBody');
    mdActiveCategory = null;
    mdHomeScroll = 0;
    body.innerHTML = mdHomeHTML;
    body.scrollTop = 0;
  }
  document.getElementById('atMdBack').addEventListener('click', mdShowHome);
  document.getElementById('atMdMore').addEventListener('click', function(){
    var body = document.getElementById('atMdBody');
    body.scrollBy({top:body.clientHeight * .65,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.getElementById('atMdBody').addEventListener('scroll', mdMore, {passive:true});
  document.getElementById('atMdBody').addEventListener('toggle', function(){mdSyncExpand();requestAnimationFrame(mdMore);}, true);
  mdrawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !mdrawer.classList.contains('on')) return;
    var items = Array.prototype.slice.call(mdrawer.querySelectorAll('button, a[href], summary, [tabindex="0"]')).filter(function (el) { return el.getClientRects().length > 0; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* desktop side menu (two-pane) */
  var XD_EXTRA = window.NAV2.xdExtra;
  var xdLeftBuilt = false;
  function buildXdLeft() {
    /* deferred like buildMdBody - the off-canvas xdrawer's cat thumbs fetched
       at init too (same lazy-margin issue) */
    if (xdLeftBuilt) return;
    xdLeftBuilt = true;
    xdLeft.innerHTML = '<div class="at-xd-sec">Categories</div>' +
    Object.keys(window.NAV2.drawerCats).map(function (k) {
      var d = window.NAV2.drawerCats[k];
      return '<button class="at-xd-it at-xd-it--th" data-k="' + k + '" type="button">' + dwCatThumb(d) +
        '<span class="at-dw-qt">' + d.t + '</span>' + chevR + '</button>';
    }).join('') +
    (Object.keys(XD_EXTRA).length ? '<div class="at-xd-sec">More categories</div>' : '') +
    Object.keys(XD_EXTRA).map(function (k) {
      return '<button class="at-xd-it" data-k="' + k + '" type="button">' + XD_EXTRA[k].t + chevR + '</button>';
    }).join('') +
    '<div class="at-xd-sec">Quick links</div>' +
    '<a class="at-xd-it" href="/collections/instant-ship">Instant Ship</a>' +
    '<a class="at-xd-it" href="/collections/bathroom-packages">Shop Packages</a>' +
    '<a class="at-xd-it" href="/pages/brands">Shop by Brands</a>' +
    '<a class="at-xd-it" href="/pages/colours">Shop by Finish</a>' +
    '<a class="at-xd-it" href="/pages/brochures">Brochures</a>' +
    '<a class="at-xd-it hot" href="/collections/clearance">Clearance</a>';
  }

  function xdSelect(k) {
    var cur = xdLeft.querySelector('.at-xd-it.on[data-k]');
    if (cur && cur.dataset.k === k) return; /* same item (e.g. hovering its chevron) - don't re-render */
    Array.prototype.slice.call(xdLeft.querySelectorAll('.at-xd-it[data-k]')).forEach(function (b) {
      b.classList.toggle('on', b.dataset.k === k);
    });
    var d = window.NAV2.drawerCats[k], x = XD_EXTRA[k];
    if (d) {
      var i = 0;
      xdRight.innerHTML = '<div class="at-xd-rt"><h4>' + d.t + '</h4><a href="' + d.all + '">View all →</a></div>' +
        gdRow(d, 'at-xd-guide') +
        d.groups.map(function (g) {
          return '<div class="at-mg-g' + (g.visual ? ' at-option-group' : '') + '"><h5>' + g.h + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
            g.links.map(function (l) {
              return '<li style="--i:' + (i++) + '"><a class="at-mg-l at-mg-l--v2' + (l.visual ? ' at-option' : '') + '" href="' + l.h + '">' + dwThumb(l) +
                '<span class="at-lb"><span class="at-lt">' + l.l + '</span>' +
                (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') + '</span></a></li>';
            }).join('') + '</ul></div>';
        }).join('') +
        window.__ATHBrandHTML(k) +
        window.BSDNav.range(d) + window.__ATHFinishHTML(d);
    } else if (x) {
      xdRight.innerHTML = '<div class="at-xd-rt"><h4>' + x.t + '</h4><a href="' + x.all + '">View all →</a></div>' +
        '<a class="at-xd-im" style="aspect-ratio:16/9;margin-top:4px" href="' + x.all + '"><img src="' + dwUrl(x.img, 640) + '" alt="" loading="lazy"><span>Browse ' + x.t + ' →</span></a>';
    }
  }
  /* the extended pane lives only while the cursor is on a department
     button or inside the pane itself; a grace period absorbs accidental
     exits before it folds back to the narrow departments rail */
  var expTimer = null;
  function xdExpand() {
    clearTimeout(expTimer);
    xdrawer.classList.add('is-exp');
  }
  function xdCollapse() {
    clearTimeout(expTimer);
    expTimer = setTimeout(function () {
      xdrawer.classList.remove('is-exp');
      Array.prototype.slice.call(xdLeft.querySelectorAll('.at-xd-it.on')).forEach(function (b) {
        b.classList.remove('on');
      });
    }, 350);
  }
  function xdHoverZone(e) {
    if (e.target.closest('.at-xd-it[data-k]') || e.target.closest('.at-xd-right')) xdExpand();
    /* bottom "Shop all categories" link is neutral: hovering it must not fold
       the expanded pane out from under the cursor */
    else if (e.target.closest('.at-xd-all')) clearTimeout(expTimer);
    /* the top bar spans the full drawer width. Split it at the departments-rail
       edge: hovering the head over the EXTENDED pane keeps it open; hovering the
       head over the NON-EXTENDED (narrow) side collapses it, so reaching up to
       that side folds the pane back as expected */
    else if (e.target.closest('.at-xd-head')) {
      if (e.clientX > xdLeft.getBoundingClientRect().right) clearTimeout(expTimer);
      else xdCollapse();
    }
    else xdCollapse();
  }
  function xdOpen() {
    buildXdLeft(); /* deferred build - see buildMdBody's rationale */
    xdrawer.classList.add('on');
    dscrim.classList.add('on');
    document.body.classList.add('at-drawer-open');
  }
  function xdClose() {
    clearTimeout(expTimer);
    xdrawer.classList.remove('on', 'is-exp');
    if (!mdrawer.classList.contains('on')) {
      dscrim.classList.remove('on');
      document.body.classList.remove('at-drawer-open');
    }
  }
  xdrawer.addEventListener('mouseover', xdHoverZone);
  xdrawer.addEventListener('focusin', xdHoverZone);
  xdrawer.addEventListener('mouseleave', xdCollapse);
  document.getElementById('atMdX').addEventListener('click', mdClose);
  document.getElementById('atXdX').addEventListener('click', xdClose);
  dscrim.addEventListener('click', function () { mdClose(); xdClose(); });
  xdLeft.addEventListener('mouseover', function (e) {
    var b = e.target.closest('.at-xd-it[data-k]');
    if (b) { xdSelect(b.dataset.k); xdExpand(); }
  });
  xdLeft.addEventListener('click', function (e) {
    var b = e.target.closest('.at-xd-it[data-k]');
    if (b) { xdSelect(b.dataset.k); xdExpand(); }
  });
  /* >= 992 (desktop, mouse) gets the hover two-pane drawer; below that, all
     touch devices (incl. tablets) get the tap-accordion mobile drawer. Boundary
     matches the .at-xdrawer display:none cutoff in atelier-header.css. */
  function openMenuDrawer() { if (window.innerWidth >= 992) xdOpen(); else mdOpen(); }
  document.getElementById('atBurger').addEventListener('click', openMenuDrawer);
  var allCats = document.getElementById('atNavAllCats');
  if (allCats) allCats.addEventListener('click', function (e) { e.preventDefault(); openMenuDrawer(); });

  /* debug deep-links: #drawer / #xdrawer */
  if (location.hash === '#drawer') setTimeout(mdOpen, 400);
  if (location.hash.indexOf('#xdrawer') === 0) setTimeout(function () {
    xdOpen();
    var m = location.hash.match(/&cat=(\w+)/);
    if (m && window.NAV2.drawerCats[m[1]]) { xdSelect(m[1]); xdExpand(); }
  }, 400);

  /* ====================== LIVE SEARCH PALETTE (M4) ======================
     Reskin of the store's Algolia autocomplete: read-only queries against
     the same indexes the live site's search uses. Config is read from the
     Algolia app's page globals when present, else the known public
     search-only key (CORS-open by design). The app itself is untouched. */
  function algoliaConf() {
    try {
      var c = window.algoliaShopify && window.algoliaShopify.config;
      if (c && c.app_id && c.search_api_key) {
        var prefix = c.index_prefix || 'shopify_';
        return { app: c.app_id, key: c.search_api_key, prod: prefix + 'products', coll: prefix + 'collections' };
      }
    } catch (err) { /* fall through to known config */ }
    return { app: '5TBKK66MTH', key: 'a8ded3c32842ccf66d52497783800f1f', prod: 'shopify_products', coll: 'shopify_collections' };
  }

  var spal = $('#atSpal'), spMain = $('#atSpMain'), spAllL = $('#atSpAll');
  var spRail = $('#atSpRailIn'), railScroller = $('#atSpRail');
  /* curated (hit-checked 2026-07-20: ovia 413 / ovia shower station 13) */
  var POPULAR = ['ovia', 'matte black tapware', 'freestanding bath', 'wall hung vanity', 'ovia shower station', 'led mirror'];
  /* Browse: curated destinations (NOT searches) - rendered as tiles in the empty state.
     ic = a Lucide-style stroked glyph; d = a short, defensible descriptor. */
  var BROWSE = [
    /* "New in" + New badge dropped 2026-07-20 (Chris: not exactly new) - general descriptor instead */
    { h: '/collections/ovia', t: 'The Ovia Collection', d: 'Explore the range', ic: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 1.9 5.8a2 2 0 0 0 1.3 1.3L21 12l-5.8 1.9a2 2 0 0 0-1.3 1.3L12 21l-1.9-5.8a2 2 0 0 0-1.3-1.3L3 12l5.8-1.9a2 2 0 0 0 1.3-1.3z"/></svg>' },
    { h: '/collections/instant-ship', t: 'Instant Ship', d: 'Ready to ship', ic: '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>' },
    { h: '/collections/clearance', t: 'Clearance', d: 'Best prices', ic: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 8.5V4a2 2 0 0 1 2-2h4.5a2 2 0 0 1 1.4.6l9 9a2 2 0 0 1 0 2.8l-5.1 5.1a2 2 0 0 1-2.8 0l-9-9A2 2 0 0 1 2 8.5Z"/><circle cx="7" cy="7" r="1.2"/></svg>' }
  ];
  var recents = {
    get: function () { try { return JSON.parse(localStorage.getItem('bsd_recent') || '[]'); } catch (e) { return []; } },
    add: function (q) {
      if (!q) return;
      var r = this.get().filter(function (x) { return x !== q; });
      r.unshift(q);
      try { localStorage.setItem('bsd_recent', JSON.stringify(r.slice(0, 6))); } catch (e) { /* private mode */ }
    },
    clear: function () { try { localStorage.removeItem('bsd_recent'); } catch (e) { /* private mode */ } }
  };
  var spSel = -1, spAbort = null, spSeq = 0, spT = null, srchHT = null, spRevealT = null;
  /* result layout preference: GRID is the default; the user can toggle to a LIST view
     (top-right of the Products header). Remembered across searches + sessions. */
  var spView = (function () { try { return localStorage.getItem('bsd_search_view') === 'list' ? 'list' : 'grid'; } catch (e) { return 'grid'; } })();
  function viewToggleHTML() {
    function b(v, label, svg) {
      var on = spView === v;
      return '<button type="button" class="at-sp-view-b' + (on ? ' on' : '') + '" data-view="' + v +
        '" aria-label="' + label + '" aria-pressed="' + on + '">' + svg + '</button>';
    }
    /* icons mirror the /collections + /search toggle (.ac-density) for visual consistency */
    return '<span class="at-sp-view" role="group" aria-label="Result layout">' +
      b('grid', 'Grid view', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>') +
      b('list', 'List view', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="5" height="5" rx="1"/><line x1="11" y1="6.5" x2="21" y2="6.5"/><rect x="3" y="15" width="5" height="5" rx="1"/><line x1="11" y1="17.5" x2="21" y2="17.5"/></svg>') +
    '</span>';
  }
  /* flip the view in place (no re-fetch): retag the current grid + the toggle buttons */
  function setView(v) {
    spView = (v === 'list') ? 'list' : 'grid';
    try { localStorage.setItem('bsd_search_view', spView); } catch (e) { /* private mode */ }
    var grid = spMain.querySelector('.at-sp-grid');
    if (grid) grid.classList.toggle('is-list', spView === 'list');
    $$('.at-sp-view-b', spMain).forEach(function (btn) {
      var on = btn.dataset.view === spView;
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on);
    });
  }
  function isPhone() { return window.innerWidth < 768; }
  /* MOBILE focus-to-top: on phones, focusing the input lifts the search bar to the very top
     and the results sheet covers the screen below it. KEY: the header does NOT change layout
     - the chrome only FADES in place (it stays in the flow), so the document below never
     reflows. That instant header collapse / page snap was the biggest jank. The bar rises
     with a composited transform, and the sheet (position:fixed) simply covers the header's
     lower half. --at-pal-top = where the sheet starts (just under the risen bar). */
  var srchWrapEl = document.querySelector('.at-srch-wrap');
  var pillEl = srchWrapEl ? srchWrapEl.querySelector('.at-srch') : null;  // the visible input pill (the label)
  /* show the inline clear (X) only when the input has text (CSS keys off .at-srch.has-text) */
  function updateClear() { if (pillEl) pillEl.classList.toggle('has-text', !!spInput.value); }
  var TOPPAD = 10, GAP = 8;
  function reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function measurePalTop() {
    if (hdr && pillEl) hdr.style.setProperty('--at-pal-top', Math.round(pillEl.getBoundingClientRect().bottom + GAP) + 'px');
  }
  /* move the bar with a composited transform that STAYS applied while searching (a state, not
     a one-shot FLIP). reset=true clears the inline styles on transitionend (used on the way out). */
  function barShift(y, dur, reset) {
    if (!srchWrapEl) return;
    if (reducedMotion()) { srchWrapEl.style.transform = y ? 'translateY(' + y + 'px)' : ''; return; }
    srchWrapEl.style.transition = 'transform ' + dur + ' cubic-bezier(.33,0,.2,1)';
    srchWrapEl.style.transform = y ? 'translateY(' + y + 'px)' : 'translateY(0)';
    if (reset) {
      var done = function (e) {
        if (e && e.propertyName !== 'transform') return;
        srchWrapEl.removeEventListener('transitionend', done);
        if (hdr && hdr.classList.contains('is-searching')) return; // a re-entry happened mid-exit; leave the bar up
        srchWrapEl.style.transition = ''; srchWrapEl.style.transform = '';
      };
      srchWrapEl.addEventListener('transitionend', done);
    }
  }
  /* SCROLL LOCK: overflow:hidden alone doesn't reliably stop touch scrolling behind a fixed
     overlay (the page scrolls + chains). Lock html + body AND swallow touchmove everywhere
     except inside the sheet's own scroll area, so only the results list scrolls. */
  function spTouchMove(e) {
    if (e.cancelable && !(e.target && e.target.closest && e.target.closest('.at-sp-bd'))) e.preventDefault();
  }
  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('at-searching');
    document.addEventListener('touchmove', spTouchMove, { passive: false });
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.classList.remove('at-searching');
    document.removeEventListener('touchmove', spTouchMove, { passive: false });
  }
  function enterSearching() {
    if (!isPhone() || !hdr || !pillEl || hdr.classList.contains('is-searching')) return;
    var hdrTop = hdr.getBoundingClientRect().top;
    var pr = pillEl.getBoundingClientRect();
    var rise = pr.top - (hdrTop + TOPPAD);                 // how far up the bar travels
    hdr.style.setProperty('--at-pal-top', Math.round(hdrTop + TOPPAD + pr.height + GAP) + 'px');
    hdr.classList.add('is-searching');                    // chrome fades IN PLACE (no flow change)
    lockScroll();                                          // lock the page behind the sheet
    /* rise from the resting spot to the top, then hold there (composited; no layout) */
    srchWrapEl.style.transition = 'none';
    srchWrapEl.style.transform = 'translateY(0)';
    void srchWrapEl.offsetWidth;                          // commit the start frame
    barShift(-rise, '.34s', false);
  }
  function exitSearching() {
    if (!hdr || !hdr.classList.contains('is-searching')) return;
    hdr.classList.remove('is-searching');
    unlockScroll();
    barShift(0, '.3s', true);                             // drop the bar back, then clear inline styles
  }
  window.addEventListener('resize', function () { if (hdr && hdr.classList.contains('is-searching')) measurePalTop(); }, { passive: true });
  function spalShow() {
    clearTimeout(mgTimer);
    hdr.classList.add('has-search-palette');
    mgHide();
    spal.classList.add('on');
    spal.setAttribute('aria-hidden', 'false');
  }
  spalHide = function () {
    clearTimeout(spRevealT);      // cancel any pending "reveal after the bar settles"
    clearTimeout(railT);          // ...and any rail phase still waiting on the typing
    detachSweep();                // stop sweeping for previews behind a closed palette
    /* A brand scope is PER-OPEN, not sticky. Closing the palette (Esc, Cancel, the
       close button, an outside click, or opening a mega panel) drops it - reopening
       must not silently still be filtered to Fienza. If the input still holds text
       the rendered results are now stale (scoped products + a scope chip), so mark
       them for a re-query on the next reveal rather than showing a lie. */
    if (scope) { scope = null; scopeStale = true; }
    spal.classList.remove('on');
    hdr.classList.remove('has-search-palette');
    spal.setAttribute('aria-hidden', 'true');
    exitSearching();
    spSel = -1;
  };
  function esch(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* ============================================================
     CONTEXT RAIL (2026-07-08)  -  the palette's left column.
     ------------------------------------------------------------
     Swaps by state: featured brands (nothing typed) / range families
     (a brand or range name) / collections (anything else) / brand
     categories (a scoped brand with no ranges, e.g. Hotwire, Zumi).

     DATA: range families come from the `range:` TAG facet on
     shopify_products (136 ranges / 3,668 products). The range smart
     collections are NOT in the shopify_collections index, so the
     Collections strip could never surface them - that is the gap this
     fills. All parameters are per-query; the shared live index is not
     reconfigured.

     KNOWN LIMITS (deliberate):
       - `meta` is {} on every record: no metafields, so no
         colour_finish_name / colour_hex. Finish dots are SAMPLED from
         each hit's colour-* collections and no total is ever printed.
       - Preview relevance needs prime-type optionalFilters + a
         product_type deny + a title deny + model dedupe, or a Kaya
         preview is three cabinet knobs. Same ruleset as
         sections/atelier-range-rail.liquid.
       - inventory_available is false on every record. No stock UI.
     ============================================================ */
  var FEATURED = window.ATBrandLogo || [];

  var DOMINANCE = 0.60;   /* the top range must own >=60% of strictly-matched hits.
                             Measured live: range names sit at 82-99% (kaya 98,
                             empire 99, mecca shower 95); the worst pure-category
                             query tops out at 42.9% ("bath shelf"). A lower gate
                             shows an ADP range rail for the word "vanity". */
  var MIN_COUNT  = 3;     /* each shown range needs >=3 matching products */
  var RAIL_MIN_Q = 2;     /* below this the RAIL stays quiet (products still search) */
  var RAIL_DELAY = 260;   /* ms of quiet before the rail spends an operation */
  var LAZY_MARGIN = 240;  /* px beyond the scroller before a card is worth fetching */

  function isNarrow() { return window.innerWidth < 992; }   /* the palette's own breakpoint */
  function maxRanges() { return isNarrow() ? 5 : 8; }

  /* ---- cost control -------------------------------------------------------
     Algolia bills per sub-request, not per POST. Three caches plus a skip keep
     this feature cheaper than the palette it replaces:
       railCache    - a brand's rail facet is f(vendor), identical for "fienza",
                      "fienza basin", "fienza kaya mixer". Non-brand: f(query).
       previewCache - a range's previews never depend on the query, so a range
                      costs at most ONE operation per session, ever.
       collCache    - collections per query.
       pure-category skip - a query of only category/finish/filler words can
                      never clear the dominance gate, so its facet request is
                      provably wasted. Any unrecognised token means we fire it
                      anyway: fail-safe costs an op, never loses a rail.
     Plus: the rail runs as a SECOND PHASE, after the typing settles, so the
     intermediate prefixes of "f-i-e-n-z-a" never buy a facet request. */
  var railCache = {}, previewCache = {}, collCache = {}, previewPending = {};
  var railT = null, previewIO = null;
  var scope = null;           /* active brand scope (a FEATURED entry) or null */
  var scopeStale = false;     /* the palette closed while scoped: re-query on reopen */
  var lastProd = null;

  var COARSE = ('bath baths tub tubs vanity vanities toilet toilets loo wc basin basins shower showers ' +
    'mirror mirrors tapware tap taps mixer mixers sink sinks towel towels rail rails heating heated ' +
    'waste wastes handle handles trap traps grate drain outlet spout spouts hook hooks ring rings ' +
    'cabinet cabinets bathtub bathtubs freestanding wall floor tall').split(' ');
  var FINISH_TOKENS = ('black white chrome nickel gold brass gunmetal graphite copper bronze champagne ' +
    'stainless steel matte gloss brushed satin polished silver').split(' ');
  var FILLER = ('a an the and or of for with in on my our new set piece pieces mm cm').split(' ');
  var KNOWN_WORD = {};
  COARSE.concat(FINISH_TOKENS, FILLER).forEach(function (w) { KNOWN_WORD[w] = 1; });

  /* true if EVERY token is a known category / finish / filler word (or a number) */
  function isPureCategory(cleaned) {
    var text = ' ' + String(cleaned || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
    if (text.trim() === '') return false;
    if (window.BSDSearch && BSDSearch.GRANULAR) {           /* consume "bottle trap", "shower head" ... */
      BSDSearch.GRANULAR.forEach(function (g) {
        g.p.forEach(function (phrase) {
          var pat = ' ' + phrase + ' ';
          while (text.indexOf(pat) !== -1) text = text.replace(pat, '  ');
        });
      });
    }
    var toks = text.trim().split(/\s+/).filter(Boolean);
    if (!toks.length) return true;
    return toks.every(function (t) { return KNOWN_WORD[t] || /^\d+$/.test(t); });
  }

  /* brand slugs, LONGEST FIRST, or "modern-national-star" becomes "National Star" */
  var BRAND_SLUGS = ('architectural-designer-products-adp,greens-tapware,modern-national,johnson-suisse,' +
    'pietra-bianca,art-australia,madu-living,thermogroup,aquaperla,stormtech,linkware,' +
    'oliveri,poseidon,hotwire,norico,mercio,fienza,linsol,metlam,rubine,zanda,caroma,forme,alia,acl-co,' +
    'geberit,meir,nero,ovia,adp,rak,zumi,luna,aquato').split(',')
    .sort(function (a, b) { return b.length - a.length; });

  function titleCase(s) {
    return s.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  function parseRangeTag(tag) {
    var slug = tag.replace(/^range:/, ''), brandSlug = '', rest = slug, i;
    for (i = 0; i < BRAND_SLUGS.length; i++) {
      if (slug.indexOf(BRAND_SLUGS[i] + '-') === 0) { brandSlug = BRAND_SLUGS[i]; rest = slug.slice(brandSlug.length + 1); break; }
    }
    return { tag: tag, handle: slug,
      brand: brandSlug ? (brandSlug === 'adp' ? 'ADP' : titleCase(brandSlug)) : '',
      name: titleCase(rest) || titleCase(slug) };
  }

  /* preview curation - without it a Kaya preview is three cabinet knobs */
  var PRIME_TYPES = ['Bathroom Tapware', 'Basin Mixers', 'Basin Mixer Taps', 'Shower Mixers/Wall Mixers',
    'Wall Basin Mixers', 'Tall Basin Mixers', 'Showers', 'Shower Heads', 'Bath Spouts', 'Bathroom Vanities',
    'Bathroom Basins', 'Bathtubs', 'Freestanding Baths', 'Toilet Suites', 'Kitchen, Laundry and Butler Sinks',
    'Mirrors & Shaving Cabinets', 'LED Mirrors'];
  var DENY_TYPES = ['Door Hardware', 'Cabinet Handles', 'Door Handles', 'Commercial Door Hardware',
    'Heated Towel Rails', 'Heated Rails', 'Disabled Shower Products', 'Disability Basin Mixers',
    'Back-to-Wall Care Toilets', 'Underfloor Heating', 'Heating Thermostats'];
  var DENY_TITLE = /\b(dda|care|disabled|ambulant|grab rail|spare|replacement|cartridge only|body only|trim only|toilet brush|knob)\b/i;
  var FINISH_RE = /\b(matte black|matte white|gloss white|brushed nickel|brushed gold|brushed brass|urban brass|tiger bronze|gun ?metal|graphite|brushed copper|lustre bronze|brushed bronze|champagne|stainless steel|chrome|black|white|gold|nickel|copper|bronze)\b/gi;
  var NOISE_RE = /\b(\d+ ?mm|plate|outlet|inlet|rough[- ]?in|assembly|only|with|set)\b/gi;

  var TYPE_LABEL = {
    'Bathroom Tapware': 'Tapware', 'Basin Mixers': 'Mixers', 'Basin Mixer Taps': 'Mixers',
    'Wall Basin Mixers': 'Mixers', 'Tall Basin Mixers': 'Mixers', 'Shower Mixers/Wall Mixers': 'Mixers',
    'Bathroom Accessories': 'Accessories', 'Robe Hooks': 'Accessories', 'Towel Rings': 'Accessories',
    'Toilet Paper Holders': 'Accessories', 'Towel Bars & Rails': 'Rails', 'Heated Towel Rails': 'Rails',
    'Showers': 'Showers', 'Shower Heads': 'Showers', 'Bath Spouts': 'Spouts',
    'Bathroom Vanities': 'Vanities', 'Bathroom Basins': 'Basins', 'Bathtubs': 'Baths',
    'Freestanding Baths': 'Baths', 'Toilet Suites': 'Toilets',
    'Mirrors & Shaving Cabinets': 'Mirrors', 'LED Mirrors': 'Mirrors',
    'Kitchen, Laundry and Butler Sinks': 'Sinks', 'Laundry Tubs': 'Sinks',
    'Cabinet Handles': 'Handles', 'Door Hardware': 'Handles',
    'Shower Wastes': 'Wastes', 'Floor wastes': 'Wastes', 'Pop-up Wastes': 'Wastes'
  };
  var BRAND_PREFIX_RE = /^(Fienza|Nero|Meir|Modern National|Mercio|Ovia|Linsol|ADP|Greens - |Greens) /;

  /* colour-<slug> collection -> canonical .at-fsw--<family> class. The store has 46
     colour-* collections but only these map to a finish FAMILY with a swatch in the
     shared gradient library. Timber/stone decor colours (scandi-oak, walnut, malibu,
     liquorice) and two-tone oddities (brass-gunmetal) have NO canonical swatch and
     are SKIPPED - never approximated with an invented gradient. Family matching is
     by family, not exact slug: Fienza's "Urban Brass" is the gold family. */
  var FINISH_FAMILY = {
    'matte-black': 'matte-black',
    'matte-white': 'matte-white', 'white-matte': 'matte-white', 'matte-white-basin': 'matte-white',
    'gloss-white': 'white', 'gloss-white-basin': 'white', 'white': 'white',
    'black': 'black', 'grey': 'grey',
    'chrome': 'chrome', 'gunmetal': 'gunmetal', 'stainless-steel': 'stainless-steel',
    'brushed-gold': 'brushed-gold', 'urban-brass': 'brushed-gold', 'brass': 'brushed-gold',
    'brushed-copper': 'brushed-copper', 'brushed-bronze': 'brushed-bronze', 'champagne': 'champagne'
  };
  var FAMILY_ORDER = ['matte-black', 'black', 'gunmetal', 'grey', 'brushed-bronze', 'brushed-copper',
    'brushed-gold', 'champagne', 'brushed-nickel', 'warm-brushed-nickel', 'stainless-steel',
    'chrome', 'matte-white', 'white'];
  function famLabel(f) { return f.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

  /* ---- Algolia helpers (same public search-only key as the palette) -------- */
  function algolia(requests) {
    var A = algoliaConf();
    return fetch('https://' + A.app + '-dsn.algolia.net/1/indexes/*/queries', {
      method: 'POST',
      headers: { 'X-Algolia-Application-Id': A.app, 'X-Algolia-API-Key': A.key },
      body: JSON.stringify({ requests: requests })
    }).then(function (r) { if (!r.ok) throw new Error('algolia ' + r.status); return r.json(); })
      .then(function (d) { return d.results; });
  }
  function vendorFilter(vendors) {
    return vendors.map(function (v) { return 'vendor:"' + v + '"'; }).join(' OR ');
  }
  function brandFor(vendors) {
    if (!vendors || !vendors.length) return null;
    for (var i = 0; i < FEATURED.length; i++) if (FEATURED[i].v[0] === vendors[0]) return FEATURED[i];
    return { name: vendors[0].replace(/ Brand$/, ''), coll: '' };
  }

  function rangesFromFacet(result, dominance) {
    var tags = (result && result.facets && result.facets.tags) || {}, out = [], k;
    for (k in tags) if (tags.hasOwnProperty(k) && k.indexOf('range:') === 0 && tags[k] >= MIN_COUNT) out.push({ tag: k, count: tags[k] });
    out.sort(function (a, b) { return b.count - a.count; });
    if (!out.length) return [];
    if (dominance && result.nbHits && (out[0].count / result.nbHits) < dominance) return [];
    var shown = out.slice(0, maxRanges()).map(function (r) { var p = parseRangeTag(r.tag); p.count = r.count; return p; });
    shown.total = out.length;
    return shown;
  }

  /* brand categories, from the product_type facet already fetched */
  function typesFromFacet(result, brand) {
    var pt = (result && result.facets && result.facets.product_type) || {};
    var strip = brand ? new RegExp('^' + brand.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[-]?\\s*', 'i') : null;
    var seen = {}, out = [];
    Object.keys(pt).sort(function (a, b) { return pt[b] - pt[a]; }).forEach(function (t) {
      if (!t || t === 'false') return;
      var label = (strip ? t.replace(strip, '') : t).replace(BRAND_PREFIX_RE, '').trim();
      if (!label) return;
      var key = label.toLowerCase();
      if (seen[key]) { seen[key].n += pt[t]; return; }
      seen[key] = { label: label, n: pt[t] };
      out.push(seen[key]);
    });
    return out.slice(0, 8);
  }

  /* ---- rail renderers ----------------------------------------------------- */
  function logoHTML(b, cls) {
    var img = '<img src="' + esch(b.logo) + '" alt="' + esch(b.name) + '">';
    if (!b.lockup) return img;   /* every mark is a wordmark except Modern National */
    return '<span class="' + (cls || 'at-sp-br-lock') + '">' + img + '<span class="at-sp-br-word">Modern National</span></span>';
  }
  function scopeChipHTML() {
    if (!scope) return '';
    return '<div class="at-sp-scope">' +
      '<span class="at-sp-scope-lg">' + logoHTML(scope, 'at-sp-scope-lock') + '</span>' +
      '<small>Scoped</small>' +
      '<button class="at-sp-scope-x" id="atSpScopeX" type="button" aria-label="Clear brand scope">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg></button></div>';
  }
  function renderBrands(note) {
    detachSweep();
    if (!spRail || !FEATURED.length) return;
    spRail.innerHTML = scopeChipHTML() +
      '<div class="at-sp-rail-h"><span>Brands we stock</span></div>' +
      (note ? '<p class="at-sp-rail-note">' + esch(note) + '</p>' : '') +
      '<div class="at-sp-brands at-sp-strip">' + FEATURED.map(function (b, i) {
        return '<button type="button" class="at-sp-br at-sp-br--' + b.k + '" style="--i:' + i + '" data-brand="' + esch(b.k) + '" aria-label="Search ' + esch(b.name) + '">' +
          logoHTML(b) +
          '<svg class="at-sp-br-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>' +
        '</button>';
      }).join('') + '</div>' +
      /* the tiles are only the featured set - the full roster lives on the
         brands page, and without this link the rail undersells the range */
      '<a class="at-sp-rall" href="/pages/brands">See all brands &rarr;</a>';
  }
  function renderRanges(ranges, brand, q) {
    if (!spRail) return;
    var brandName = brand ? brand.name : '';
    var more = (ranges.total || ranges.length) - ranges.length;
    spRail.innerHTML = scopeChipHTML() +
      '<div class="at-sp-rail-h"><span>Ranges</span><em>' +
        (brandName ? esch(brandName) + ' &middot; ' : '') +
        (more > 0 ? ranges.length + ' of ' + ranges.total : ranges.length) + '</em></div>' +
      '<div class="at-sp-ranges at-sp-strip">' + ranges.map(function (r, i) {
        return '<a class="at-sp-rc" style="--i:' + i + '" href="/collections/' + esch(r.handle) + '" data-tag="' + esch(r.tag) + '" data-q="' + esch(q || '') + '">' +
          '<span class="at-sp-rc-ims">' +
            '<span class="at-sp-rc-im at-sp-rc-im--sk"></span>' +
            '<span class="at-sp-rc-im at-sp-rc-im--sk"></span>' +
            '<span class="at-sp-rc-im at-sp-rc-im--sk"></span>' +
          '</span>' +
          (brandName ? '' : '<span class="at-sp-rc-br">' + esch(r.brand) + '</span>') +
          '<span class="at-sp-rc-nm">' + esch(r.name) + '</span>' +
          '<span class="at-sp-rc-mt">&nbsp;</span>' +
          '<span class="at-sp-rc-ft"><span class="at-sp-fins"></span>' +
          '<span class="at-sp-rc-ct">' + r.count.toLocaleString() + ' products</span></span>' +
        '</a>';
      }).join('') + '</div>' +
      /* past the cap: the brand collection is the only real destination - the store
         has no per-brand range index page */
      (more > 0 && brand && brand.coll
        ? '<a class="at-sp-rall" href="/collections/' + esch(brand.coll) + '">' +
            more + ' more ' + (more === 1 ? 'range' : 'ranges') + ' &middot; shop all ' + esch(brandName) + ' &rarr;</a>'
        : '');
  }
  function renderCollections(hits, q) {
    detachSweep();
    if (!spRail) return;
    spRail.innerHTML = scopeChipHTML() +
      '<div class="at-sp-rail-h"><span>Collections</span></div>' +
      '<div class="at-sp-colls at-sp-strip">' + hits.map(function (c, i) {
        var tt = (c._highlightResult && c._highlightResult.title && c._highlightResult.title.value) || esch(c.title || '');
        return '<a class="at-sp-coll" style="--i:' + i + '" href="/collections/' + esch(c.handle) + '" data-q="' + esch(q || '') + '"><b>' + tt + '</b>' +
          (c.products_count ? '<small>' + c.products_count.toLocaleString() + '</small>' : '') + '</a>';
      }).join('') + '</div>';
  }
  function renderTypes(types, brand) {
    detachSweep();
    if (!spRail) return;
    spRail.innerHTML = scopeChipHTML() +
      '<div class="at-sp-rail-h"><span>Categories</span><em>' + esch(brand ? brand.name : '') + '</em></div>' +
      '<p class="at-sp-rail-note">' + esch(brand ? brand.name : 'This brand') + ' isn&rsquo;t grouped into ranges. Browse by category instead.</p>' +
      '<div class="at-sp-colls at-sp-strip">' + types.map(function (t, i) {
        return '<button type="button" class="at-sp-coll at-sp-cat" style="--i:' + i + '" data-q="' + esch(t.label) + '">' +
          '<b>' + esch(t.label) + '</b><small>' + t.n.toLocaleString() + '</small></button>';
      }).join('') + '</div>';
  }
  function renderRailSkeleton() {
    if (!spRail) return;
    var cells = '';
    for (var i = 0; i < 4; i++) cells += '<span class="at-sp-coll at-sp-coll--sk"></span>';
    spRail.innerHTML = scopeChipHTML() + '<div class="at-sp-rail-h"><span>&nbsp;</span></div><div class="at-sp-colls">' + cells + '</div>';
  }
  function railFromCollections(hits, q) {
    if (hits && hits.length) renderCollections(hits, q); else renderBrands('Nothing to narrow by yet.');
  }

  /* ---- previews: lazy + cached, one operation per range per session -------- */
  function primeOF() { return PRIME_TYPES.map(function (t) { return 'product_type:' + t + '<score=1>'; }); }
  function modelKey(t) {
    return String(t).toLowerCase().replace(FINISH_RE, ' ').replace(NOISE_RE, ' ')
      .replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function computePreview(result) {
    var hits = (result && result.hits) || [], seen = {}, picks = [], fins = {}, i, h, key;
    /* finish sample: each hit's colour-* collections are the ONLY finish signal
       Algolia carries (meta is empty; `collections` is filterOnly so it cannot be
       faceted). Sampled - so no total is ever printed. */
    for (i = 0; i < hits.length; i++) {
      (hits[i].collections || []).forEach(function (c) {
        if (c.indexOf('colour-') !== 0) return;
        var fam = FINISH_FAMILY[c.slice(7)];
        if (fam) fins[fam] = 1;                 /* unmapped colours skipped, not guessed */
      });
    }
    for (i = 0; i < hits.length && picks.length < 3; i++) {      /* distinct MODELS */
      h = hits[i];
      if (DENY_TITLE.test(h.title) || !h.product_image) continue;
      key = modelKey(h.title);
      if (!key || seen[key]) continue;
      seen[key] = 1; picks.push(h);
    }
    for (i = 0; i < hits.length && picks.length < 3; i++) {      /* thin range: relax to handles */
      h = hits[i];
      if (DENY_TITLE.test(h.title) || !h.product_image) continue;
      if (picks.indexOf(h) === -1) picks.push(h);
    }
    var pt = (result && result.facets && result.facets.product_type) || {};
    /* strip the brand prefix BEFORE the label lookup: the raw type is often
       "Fienza Bathroom Tapware", which misses TYPE_LABEL and leaks the long name */
    var mix = Object.keys(pt).sort(function (a, b) { return pt[b] - pt[a]; })
      .map(function (t) { var s = t.replace(BRAND_PREFIX_RE, ''); return TYPE_LABEL[t] || TYPE_LABEL[s] || s; })
      .filter(function (l, idx, arr) { return arr.indexOf(l) === idx; })
      .slice(0, 3).join(' · ');
    return {
      imgs: picks.map(function (p) { return p.product_image + (p.product_image.indexOf('?') > -1 ? '&' : '?') + 'width=400'; }),
      mix: mix,
      fins: FAMILY_ORDER.filter(function (f) { return fins[f]; }).slice(0, 5)
    };
  }
  function paintCard(card, data) {
    $$('.at-sp-rc-im', card).forEach(function (box, n) {
      box.classList.remove('at-sp-rc-im--sk');
      var src = data.imgs[n];
      if (!src) { box.classList.add('at-sp-rc-im--none'); return; }
      box.innerHTML = '<img src="' + esch(src) + '" alt="" loading="lazy">';
    });
    var mt = $('.at-sp-rc-mt', card); if (mt && data.mix) mt.textContent = data.mix;
    var fw = $('.at-sp-fins', card);
    /* .at-fsw--<family> is the canonical gradient; .at-sp-fin adds only ring + size */
    if (fw) fw.innerHTML = data.fins.map(function (f) {
      return '<i class="at-sp-fin at-fsw--' + f + '" title="' + esch(famLabel(f)) + '"></i>';
    }).join('');
  }
  /* NO sequence guard here, deliberately. A preview is keyed by RANGE TAG and never
     depends on the query, so a response is always worth caching and painting. An
     earlier version discarded in-flight batches whenever a newer one started - and
     because intersecting cards are unobserve()d immediately, the dropped cards were
     never retried and sat in skeleton forever. Scrolling the rail reproduced it every
     time (flush #1 = Eleanor/Edge/Minka, flush #2 = Pebble -> only Pebble painted).
     Instead: dedupe in-flight tags, and let every response land. */
  function fetchPreviews(tags) {
    tags = tags.filter(function (t) { return !previewPending[t] && !previewCache[t]; });
    if (!tags.length) return;
    tags.forEach(function (t) { previewPending[t] = 1; });
    var A = algoliaConf();
    var of = encodeURIComponent(JSON.stringify(primeOF()));
    var reqs = tags.map(function (tag) {
      var f = 'tags:"' + tag + '"' + DENY_TYPES.map(function (t) { return ' AND NOT product_type:"' + t + '"'; }).join('');
      return { indexName: A.prod, query: '',
        params: 'hitsPerPage=20&distinct=true&filters=' + encodeURIComponent(f) +
          '&optionalFilters=' + of + '&sumOrFiltersScores=true' +
          '&facets=' + encodeURIComponent('["product_type"]') + '&maxValuesPerFacet=30' +
          '&attributesToRetrieve=' + encodeURIComponent('["title","handle","product_image","price","collections","product_type"]') };
    });
    algolia(reqs).then(function (res) {
      res.forEach(function (r, i) {
        delete previewPending[tags[i]];
        var data = computePreview(r);
        previewCache[tags[i]] = data;                 /* cached for the whole session */
        /* re-query the card: the rail may have re-rendered while this was in flight */
        var card = spRail && spRail.querySelector('.at-sp-rc[data-tag="' + tags[i] + '"]');
        if (card) paintCard(card, data);
      });
      if (previewSweep) previewSweep();               /* anything newly in view? */
    }).catch(function () {
      /* release the tags so a later intersection can retry; cards keep their skeletons
         and the results are never blocked */
      tags.forEach(function (t) { delete previewPending[t]; });
    });
  }
  /* Which cards already sit near the scroller, by geometry. Handles both axes: the
     desktop rail scrolls vertically, the phone strip horizontally. Computed
     SYNCHRONOUSLY - the first paint must not depend on an IntersectionObserver
     delivery, which a horizontal scroller may not produce until the user swipes. */
  function nearViewport(scroller, cards) {
    var s = scroller.getBoundingClientRect(), M = LAZY_MARGIN;
    return cards.filter(function (c) {
      var b = c.getBoundingClientRect();
      return b.left < s.right + M && b.right > s.left - M && b.top < s.bottom + M && b.bottom > s.top - M;
    });
  }
  /* Lazy loading by SCROLL SWEEP, not IntersectionObserver.
     IO was the obvious tool and it was the wrong one here: each intersection burst
     started its own batch, an in-flight batch could be superseded, and intersecting
     cards were unobserve()d immediately - so a dropped batch left those cards in
     skeleton forever with nothing to retry them (Eleanor/Edge/Minka stuck while
     Pebble, the last batch, painted). IO delivery on a horizontal strip is also not
     guaranteed until the user swipes.

     A throttled sweep over the same synchronous geometry used for priming has one
     code path, is idempotent, retries naturally on the next scroll, and is
     verifiable. previewPending stops duplicate in-flight requests. */
  var previewScroller = null, previewSweep = null;
  function detachSweep() {
    if (previewScroller && previewSweep) previewScroller.removeEventListener('scroll', previewSweep);
    previewScroller = null; previewSweep = null;
  }
  function observePreviews() {
    detachSweep();
    if (!spRail) return;
    var scroller = isNarrow() ? spRail.querySelector('.at-sp-ranges') : railScroller;
    var cards = $$('.at-sp-rc', spRail);
    if (!scroller || !cards.length) return;

    function sweep() {
      var cold = cards.filter(function (c) {
        var tag = c.dataset.tag;
        if (previewCache[tag]) {                     /* cached: paint, cost nothing */
          if (c.querySelector('.at-sp-rc-im--sk')) paintCard(c, previewCache[tag]);
          return false;
        }
        return !previewPending[tag];                 /* skip anything already in flight */
      });
      if (!cold.length) { detachSweep(); return; }   /* everything resolved: stop listening */
      var due = nearViewport(scroller, cold);
      if (due.length) fetchPreviews(due.map(function (c) { return c.dataset.tag; }));
    }

    var t = null;
    previewSweep = function () { if (t) return; t = setTimeout(function () { t = null; sweep(); }, 80); };
    previewScroller = scroller;
    scroller.addEventListener('scroll', previewSweep, { passive: true });
    sweep();                                          /* prime whatever is already in view */
  }

  /* ---- PHASE 2: the rail. Runs only once the typing settles. --------------- */
  function railQuery(q, pQuery, vendors, seq) {
    if (seq !== spSeq || !spRail) return;
    var A = algoliaConf();
    /* facetingAfterDistinct: the index holds VARIANT records, so a raw facet count
       counts variants, not products. Hotwire's "Underfloor Heating" facets to 248
       records but is only 62 products (mats have a size variant each). Range tags
       happen to be unaffected (tapware is single-variant) but the counts must be
       right by construction, not by luck. */
    var railBase = 'hitsPerPage=0&facets=' + encodeURIComponent('["tags","product_type"]') +
                   '&maxValuesPerFacet=100&distinct=true&facetingAfterDistinct=true';
    var brandScoped = !!vendors.length, brand = brandFor(vendors);
    var pure = !brandScoped && isPureCategory(pQuery);
    var railKey = brandScoped ? 'v:' + vendors.join('|') : (pure ? null : 'q:' + pQuery);
    var railHit = railKey ? railCache[railKey] : null;
    var collKey = 'q:' + q;

    var reqs = [], iRail = -1, iColl = -1;
    if (railKey && !railHit) {
      /* typo tolerance is right for PRODUCTS (a shopper typing "mier" should still
         see Meir) but wrong for the rail: "kaya" is one edit from "kara", so a
         Fienza search surfaced Nero's KARA range as a peer. Separate requests, so
         the two can disagree. Verified: strict matching loses nothing legitimate.
         A brand query skips typos entirely - it facets against a VENDOR filter with
         an empty query, exact by construction. */
      reqs.push(brandScoped
        ? { indexName: A.prod, query: '',     params: railBase + '&filters=' + encodeURIComponent(vendorFilter(vendors)) }
        : { indexName: A.prod, query: pQuery, params: railBase + '&typoTolerance=false' });
      iRail = reqs.length - 1;
    }
    /* Collections only ever render in the rail, and a brand rail never shows them.
       Fetch up-front only when we already know the rail will need them (a pure
       category query cannot produce ranges); otherwise defer and pay the operation
       solely in the minority case where the dominance gate rejects. */
    if (pure && !collCache[collKey]) { reqs.push({ indexName: A.coll, query: q, params: 'hitsPerPage=6' }); iColl = reqs.length - 1; }

    var done = function (res) {
      if (seq !== spSeq) return;
      var railFacet = railHit || (iRail >= 0 ? res[iRail] : null);
      if (railKey && railFacet) railCache[railKey] = railFacet;
      if (iColl >= 0) collCache[collKey] = res[iColl].hits;

      var ranges = railFacet ? rangesFromFacet(railFacet, brandScoped ? 0 : DOMINANCE) : [];
      if (ranges.length) { renderRanges(ranges, brand, q); observePreviews(); }
      /* a scoped brand with NO ranges is a real state, not an error: Hotwire (103
         products) and Zumi (47) carry zero range: tags. Falling through to
         Collections would list store collections unrelated to the brand. */
      else if (brandScoped) renderTypes(typesFromFacet(railFacet, brand), brand);
      else if (collCache[collKey]) railFromCollections(collCache[collKey], q);
      else {
        renderRailSkeleton();
        algolia([{ indexName: A.coll, query: q, params: 'hitsPerPage=6' }]).then(function (cr) {
          if (seq !== spSeq) return;
          collCache[collKey] = cr[0].hits;
          railFromCollections(cr[0].hits, q);
        }).catch(function () { renderBrands(); });
      }
    };
    if (!reqs.length) { done([]); return; }        /* fully cached: zero operations */
    algolia(reqs).then(done).catch(function () { /* rail failure never breaks results */ });
  }

  function scheduleRail(q, pQuery, vendors, seq) {
    clearTimeout(railT);
    if (!scope && q.length < RAIL_MIN_Q) return;   /* products still search; the rail waits */
    railT = setTimeout(function () { railQuery(q, pQuery, vendors, seq); }, RAIL_DELAY);
  }
  function setScope(key) {
    scopeStale = false;
    for (var i = 0; i < FEATURED.length; i++) if (FEATURED[i].k === key) { scope = FEATURED[i]; break; }
    spInput.focus();
    var q = spInput.value.trim();
    if (q) spQuery(q); else spQuery('');
  }
  function clearScope() {
    scope = null; scopeStale = false;
    var q = spInput.value.trim();
    if (q) spQuery(q); else spEmptyState();
  }
  /* the cap changes 8 <-> 5 across 992px; re-render the rail if the user crosses it */
  var lastNarrow = isNarrow();
  window.addEventListener('resize', function () {
    if (isNarrow() === lastNarrow) return;
    lastNarrow = isNarrow();
    if (!spal.classList.contains('on')) return;
    var q = spInput.value.trim();
    if (q || scope) spQuery(q); else spEmptyState();
  }, { passive: true });

  function spEmptyState() {
    var r = recents.get();
    var sugIc = '<svg class="at-sp-sug-ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
    var goIc = '<svg class="at-sp-sug-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>';
    spMain.innerHTML =
      (r.length ? '<div class="at-sp-h">Recent searches <button id="atSpClr" type="button">clear</button></div>' +
        '<div class="at-sp-recents">' + r.map(function (q, i) {
          /* query text wrapped so the recents row can ellipsis-cap long queries */
          return '<a class="at-sp-chip" style="--i:' + i + '" href="/search?q=' + encodeURIComponent(q) + '" data-q="' + esch(q) + '"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span class="at-sp-chip-q">' + esch(q) + '</span></a>';
        }).join('') + '</div>' : '') +
      '<div class="at-sp-h">Popular right now</div>' +
      '<div class="at-sp-sugs">' + POPULAR.map(function (q, i) {
        return '<a class="at-sp-sug" style="--i:' + i + '" href="/search?q=' + encodeURIComponent(q) + '" data-q="' + esch(q) + '">' + sugIc + '<span>' + esch(q) + '</span>' + goIc + '</a>';
      }).join('') + '</div>' +
      '<div class="at-sp-h at-sp-h--mt">Browse</div>' +
      '<div class="at-sp-tiles">' + BROWSE.map(function (b, i) {
        return '<a class="at-sp-tile" style="--i:' + i + '" href="' + b.h + '">' +
          '<span class="at-sp-tile-ic">' + b.ic + '</span>' +
          '<span class="at-sp-tile-tx"><b>' + esch(b.t) + (b.badge ? '<i class="at-sp-tag">' + esch(b.badge) + '</i>' : '') + '</b><small>' + esch(b.d) + '</small></span>' +
        '</a>';
      }).join('') + '</div>';
    spAllL.textContent = 'Open search page →';
    spAllL.href = '/search';
    renderBrands();                 // rail: featured brands (click one to scope the palette)
    spSel = -1;
  }
  function fmtHit(h) {
    var img = h.product_image || h.image || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=420'; /* larger CDN rendition so cards fill */
    var price = +h.price > 0 ? aud(Math.round(+h.price)) : '';
    var was = +h.compare_at_price > +h.price ? aud(Math.round(+h.compare_at_price)) : '';
    var tt = (h._highlightResult && h._highlightResult.title && h._highlightResult.title.value) || esch(h.title || '');
    return { img: img, price: price, was: was, tt: tt, href: '/products/' + h.handle + (h._variant ? '?variant=' + h._variant : '') };
  }
  /* skeleton while a query is in flight (delayed, so fast responses never flash it) -
     keeps the sheet from showing STALE results under a freshly-typed query. Uses the
     real result classes so the grid/row split + spacing match the incoming results. */
  function spLoading() {
    var card = '<span class="at-spc at-spc--sk"><span class="at-spc-im"></span>' +
      '<span class="at-spc-bd"><b></b><small></small><span class="at-spc-pr"><span class="at-now"></span></span></span></span>';
    var cells = '';
    for (var i = 0; i < 8; i++) cells += card;
    spMain.innerHTML = '<div class="at-sp-h">Searching&hellip;</div><div class="at-sp-grid at-sp-grid--sk' + (spView === 'list' ? ' is-list' : '') + '">' + cells + '</div>';
    spSel = -1;
  }
  /* finish-family transparency line: when the query resolved to a finish FAMILY (e.g.
     "brushed gold" -> the whole gold family), say so + name the brand-specific members
     it pulls in. The engine exposes detectFinishFamily + FINISH_FAMILIES for this. */
  function famLine(family) {
    var fam = (family && window.BSDSearch && BSDSearch.FINISH_FAMILIES) ? BSDSearch.FINISH_FAMILIES[family] : null;
    if (!fam) return '';
    return '<div class="at-sp-fam"><i class="' + esch(family) + '"></i><span>Showing the whole <b>' +
      esch(fam.label) + '</b> family <em>incl. ' + esch(fam.incl.join(', ')) + '</em></span></div>';
  }
  /* Card letterbox fill = TWO layers: the et-bg underlay (64px rendition
     stretched + CSS-blurred, in the markup so it arrives with the page - no
     white band) which the edge-tint STRIPS then overtake (shared engine
     atelier-edge-tint.js; same-frame from cache, brief crossfade only on a
     first-ever sight). SYNC: same element in snippets/atelier-product-card.liquid
     + atelier-search.js; width=64 must match the engine's probe. */
  function et32(src) {
    if (!src) return null;
    var b = src.replace(/([?&])width=\d+/, '$1width=64');
    return b !== src ? b : null;      /* no width param: skip (never a full-size underlay) */
  }
  /* NOTE: the Collections strip that used to sit above the products now lives in
     the rail (renderCollections). Everything else here is unchanged. */
  function renderResults(q, prod, family, skuQ) {
    var hits = (prod && prod.hits) || [];
    var count = (prod && prod.nbHits) ? prod.nbHits.toLocaleString() + (prod.nbHits === 1 ? ' result' : ' results') : '';
    /* SKU-shaped query: is the exact code among the hits? (dash/space-blind) */
    var anyExact = false;
    if (skuQ && window.BSDSearch && BSDSearch.skuCanon) {
      for (var x = 0; x < hits.length; x++) { if (BSDSearch.skuCanon(hits[x].sku) === skuQ) { anyExact = true; break; } }
    }
    spMain.innerHTML =
      (hits.length ? famLine(family) : '') +
      (hits.length && skuQ && !anyExact ? '<div class="at-sp-skunote">No exact match for &ldquo;' + esch(q) + '&rdquo; — closest:</div>' : '') +
      '<div class="at-sp-h"><span>Products' + (count ? ' <span class="at-sp-count">' + count + '</span>' : '') + '</span>' + (hits.length ? viewToggleHTML() : '') + '</div>' +
      (hits.length ? '<div class="at-sp-grid' + (spView === 'list' ? ' is-list' : '') + '">' + hits.map(function (h, i) {
        var f = fmtHit(h);
        var bg32 = et32(f.img);       /* soft underlay = tiny rendition, CSS-blurred */
        var off = +h.compare_at_price > +h.price ? Math.round((1 - h.price / h.compare_at_price) * 100) : 0;
        var exact = skuQ && h.sku && window.BSDSearch && BSDSearch.skuCanon && BSDSearch.skuCanon(h.sku) === skuQ;
        var skuLine = skuQ && h.sku ? '<span class="at-spc-sku' + (exact ? ' is-exact' : '') + '">' + esch(h.sku) + '</span>' : '';
        return '<a class="at-spc' + (exact ? ' at-spc--skux' : '') + '" style="--i:' + i + '" href="' + f.href + '" data-q="' + esch(q) + '">' +
          '<span class="at-spc-im">' +
            (bg32 ? '<img class="et-bg" src="' + bg32 + '" alt="" aria-hidden="true" loading="lazy" fetchpriority="low" crossorigin="anonymous">' : '') +
            (f.img ? '<img src="' + f.img + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="at-spc-bd"><b>' + f.tt + '</b><small>' + esch(h.vendor || '') + '</small>' +
          '<span class="at-spc-pr"><span class="at-now">' + f.price + '</span>' + (f.was ? '<s>' + f.was + '</s>' : '') + (off ? '<span class="at-spc-off">−' + off + '%</span>' : '') + skuLine + '</span></span></a>';
      }).join('') + '</div>'
      : '<div class="at-sp-empty">Nothing matches &ldquo;' + esch(q) + '&rdquo; — try a simpler word.</div>');
    /* strips overtake the et-bg underlay (shared engine; safe if absent) */
    if (window.ATEdgeTint) ATEdgeTint.scan(spMain);
    spAllL.innerHTML = 'Search the store for &ldquo;' + esch(q) + '&rdquo; &rarr;';
    spAllL.href = spSearchUrl(q);
    spSel = -1;
  }
  /* normalised /search URL - carries the mm/vocabulary fixes to the native
     results page on Enter. Boosts can't carry (native search has no
     optionalFilters); falls back to the raw query if the engine is absent. */
  function spSearchUrl(q) {
    var nq = (window.BSDSearch && BSDSearch.normalize) ? (BSDSearch.normalize(q) || q) : q;
    return '/search?q=' + encodeURIComponent(nq);
  }
  /* TWO PHASES.
     Phase 1 (here, immediately): PRODUCTS only - one Algolia operation. This is
     what the user is waiting to see, and it fires on every settled keystroke as
     before. The collections request that used to ride along has moved into the
     rail, which needs it only sometimes.
     Phase 2 (scheduleRail, after the typing stops): the rail. Every intermediate
     prefix of "f-i-e-n-z-a" used to buy its own facet request; now only the word
     the user actually stopped on does. */
  function spQuery(q) {
    var seq = ++spSeq;
    if (spAbort) spAbort.abort();
    spAbort = new AbortController();
    /* delayed skeleton: only if the response is slow (>180ms), so a quick reply never flashes it */
    var skT = setTimeout(function () { if (seq === spSeq) spLoading(); }, 180);
    var A = algoliaConf();
    /* search intelligence: enhance the PRODUCTS query only. Engine is optional -
       if bsd-search-core.js is missing or throws, fall back to today's behaviour. */
    var BASE = 'hitsPerPage=12&distinct=true&clickAnalytics=false';
    var pQuery = q, pParams = BASE, family = null, vendors = [], intent = null, boosts = [];
    if (window.BSDSearch && BSDSearch.enhance) {
      try {
        var e = BSDSearch.enhance(q, { intents: true });
        pQuery = e.query || q;
        boosts = e.optionalFilters || [];
        pParams = BSDSearch.appendOptionalFilters(pParams, boosts);
        if (e.facetFilters && e.facetFilters.length) {
          pParams += '&facetFilters=' + encodeURIComponent(JSON.stringify(e.facetFilters));
          intent = e;
        }
        /* family/brand read the FULL text - an intent only strips words
           (a size, "floor standing") that name neither */
        family = BSDSearch.detectFinishFamily ? BSDSearch.detectFinishFamily(pQuery) : null;
        vendors = (BSDSearch.detectBrand && BSDSearch.detectBrand(pQuery)) || [];
      } catch (err) { pQuery = q; pParams = BASE; family = null; vendors = []; intent = null; boosts = []; }
    }
    /* an active brand scope overrides brand detection and filters the results */
    var scopeF = scope ? vendorFilter(scope.v) : '';
    if (scope) { vendors = scope.v; pParams += '&filters=' + encodeURIComponent(scopeF); }

    /* size / floor-standing intent (engine v1.7): request 0 runs the stripped
       text under the facet filter; each EXTRA re-runs the original text over
       the products that filter excludes, so nothing that matches today is
       lost (Chris's inclusion rule). Extras are disjoint from request 0. */
    var reqs = [{ indexName: A.prod, query: pQuery, params: pParams }];
    if (intent) {
      intent.extras.forEach(function (x) {
        var f = scopeF ? '(' + scopeF + ') AND ' + x.filters : x.filters;
        reqs.push({ indexName: A.prod, query: x.query,
          params: BSDSearch.appendOptionalFilters('hitsPerPage=3&distinct=true&clickAnalytics=false&' + BSDSearch.EXTRA_PARAMS, boosts) + '&filters=' + encodeURIComponent(f) });
      });
    }
    var sig = spAbort.signal;   /* this query's own signal - spAbort moves on with the next keystroke */
    function algolia(requests) {
      return fetch('https://' + A.app + '-dsn.algolia.net/1/indexes/*/queries', {
        method: 'POST',
        signal: sig,
        headers: { 'X-Algolia-Application-Id': A.app, 'X-Algolia-API-Key': A.key },
        body: JSON.stringify({ requests: requests })
      }).then(function (res) {
        if (!res.ok) throw new Error('algolia ' + res.status);
        return res.json();
      });
    }

    algolia(reqs).then(function (data) {
      var prod = data.results[0];
      if (!intent) return prod;
      /* merge: request-0 hits, with up to 3 slots kept for extras so a
         title-only match ("... 1200 Vanity" with no width data) still shows */
      var extra = [], seen = {}, i, j, nb = prod.nbHits || 0;
      for (i = 1; i < data.results.length; i++) {
        var r = data.results[i];
        nb += r.nbHits || 0;
        for (j = 0; j < (r.hits || []).length; j++) {
          var h = r.hits[j];
          if (!seen[h.id]) { seen[h.id] = 1; extra.push(h); }
        }
      }
      extra = extra.slice(0, 3);
      var main = (prod.hits || []).filter(function (h) { return !seen[h.id]; });
      var merged = { nbHits: nb, hits: main.slice(0, 12 - extra.length).concat(extra) };
      /* size search: point each multi-size card at its variant of that width
         (link + price), BEFORE rendering - a price swapped in afterwards
         would visibly jump. One batched round trip; on failure the cards
         simply keep the product link and representative price. */
      var vr = intent.size ? BSDSearch.sizeVariantRequests(merged.hits, intent.size) : [];
      if (!vr.length) return merged;
      return algolia(vr.map(function (x) { return { indexName: A.prod, params: x.params }; })).then(function (vd) {
        vr.forEach(function (x, k) {
          var v = BSDSearch.variantForSize((vd.results[k] && vd.results[k].hits) || [], intent.size);
          if (!v) return;
          var h = Object.assign({}, merged.hits[x.i]);
          h.price = v.price; h.compare_at_price = v.compare_at_price; h._variant = v.objectID;
          merged.hits[x.i] = h;
        });
        return merged;
      }, function (err) { if (err && err.name === 'AbortError') throw err; return merged; });
    }).then(function (prod) {
      clearTimeout(skT);
      if (seq !== spSeq) return;
      lastProd = prod;
      /* SKU-shaped query (one token, letters+digits - "MIL09CH"): cards grow a
         SKU line and an exact match is outlined; detection lives in the engine */
      var skuQ = (window.BSDSearch && BSDSearch.detectSku) ? BSDSearch.detectSku(pQuery) : null;
      renderResults(q, prod, family, skuQ);
    }).catch(function (err) {
      clearTimeout(skT);
      if (err.name === 'AbortError' || seq !== spSeq) return;
      spMain.innerHTML = '<div class="at-sp-empty">Search is unavailable right now — <a href="' + spSearchUrl(q) + '" style="color:var(--at-brass-bright);font-weight:600">open the search page</a> instead.</div>';
    });

    scheduleRail(q, pQuery, vendors, seq);
  }
  spInput.addEventListener('input', function () {
    var q = spInput.value.trim();
    updateClear();
    clearTimeout(spRevealT);      // user is typing - reveal the panel now, don't wait for the bar
    spalShow();
    clearTimeout(spT);
    if (!q) { if (scope) spQuery(''); else spEmptyState(); return; }
    spT = setTimeout(function () { spQuery(q); }, 140);
  });
  spInput.addEventListener('focus', function () {
    /* on a FRESH mobile entry the bar is rising (FLIP). Hold the panel until the bar is
       stationary, THEN fade + stagger it in - revealing it mid-rise looked busy/flashy.
       Typing (above) cancels the wait and shows results immediately. Desktop = instant. */
    var fresh = isPhone() && hdr && !hdr.classList.contains('is-searching');
    updateClear();
    enterSearching();
    var reveal = function () {
      spalShow();
      var rq = spInput.value.trim();
      if (!rq) { if (scope) spQuery(''); else spEmptyState(); return; }
      /* text still in the box, but we dropped a scope on the way out: the visible
         results and rail belong to the old scope. Re-query unscoped. */
      if (scopeStale) { scopeStale = false; spQuery(rq); }
    };
    clearTimeout(spRevealT);
    if (fresh) { spRevealT = setTimeout(reveal, 200); } else { reveal(); }
  });
  /* explicit close for the full-bleed mobile palette (visible only < 768px) */
  var spClose = document.getElementById('atSpClose');
  if (spClose) spClose.addEventListener('click', function () { spInput.blur(); spalHide(); });
  /* Cancel: the search-mode exit on phones (sits in the lifted search bar) */
  var spCancel = document.getElementById('atSrchCancel');
  if (spCancel) spCancel.addEventListener('click', function () { spInput.blur(); spalHide(); });
  /* inline X: clears the text, keeps focus + keyboard, returns to the empty state.
     Act on POINTERDOWN, not click: on touch the input blurs on first touch and that tap gets
     consumed dismissing the keyboard/autocorrect, so a click needed a SECOND tap. pointerdown
     fires before the blur - preventDefault keeps the input focused and we clear immediately. */
  var spClear = document.getElementById('atSrchClear');
  if (spClear) {
    spClear.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      spInput.value = '';
      updateClear();
      if (scope) spQuery(''); else spEmptyState();
      spInput.focus();
    });
  }
  document.addEventListener('click', function (e) {
    var vb = e.target.closest('.at-sp-view-b');
    if (vb) { setView(vb.dataset.view); return; }
    if (e.target.closest('#atSpClr')) { recents.clear(); spEmptyState(); return; }
    /* rail: a brand tile SCOPES the palette rather than navigating away */
    var br = e.target.closest('.at-sp-br');
    if (br) { e.preventDefault(); setScope(br.dataset.brand); return; }
    if (e.target.closest('#atSpScopeX')) { e.preventDefault(); clearScope(); return; }
    /* rail: a brand category refines the query inside the scope */
    var cat = e.target.closest('.at-sp-cat');
    if (cat) { e.preventDefault(); spInput.value = cat.dataset.q; updateClear(); spQuery(cat.dataset.q); spInput.focus(); return; }
    /* .at-sp-cc was the old in-results collections strip; the rail's .at-sp-coll
       carries the same data-q, and range cards record the search too */
    var it = e.target.closest('.at-spc,.at-sp-chip,.at-sp-sug,.at-sp-coll:not(.at-sp-cat),.at-sp-rc');
    if (it && it.dataset.q) recents.add(it.dataset.q);
    /* outside-click-to-close applies ONLY to the desktop dropdown. In the mobile full-screen
       search mode there is no "outside" (Cancel/Esc close it) - and crucially, the focus->bar-
       rise moves the input out from under the tap, so the opening click would otherwise hit-test
       "outside" and immediately close + cancel the reveal. Skip it while searching. */
    if (hdr && hdr.classList.contains('is-searching')) return;
    if (!e.target.closest('.at-spal') && !e.target.closest('.at-srch')) spalHide();
  });
  spInput.addEventListener('keydown', function (e) {
    /* main column first (results / suggestions), then the rail - the rail precedes
       the results in DOM order, so this cannot be one querySelectorAll. Only real
       links take part: brand tiles and category rows are <button>s with no href. */
    var items = $$('.at-spc,.at-sp-sug', spMain)
      .concat(spRail ? $$('.at-sp-rc,.at-sp-coll:not(.at-sp-cat)', spRail) : []);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!items.length) return;
      spSel = (spSel + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items.forEach(function (x, i) { x.classList.toggle('sel', i === spSel); });
      items[spSel].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      e.preventDefault();
      var q = spInput.value.trim();
      if (spSel >= 0 && items[spSel]) { recents.add(q); window.location.href = items[spSel].href; }
      else if (q) { recents.add(q); window.location.href = spSearchUrl(q); }
    } else if (e.key === 'Escape') {
      spalHide();
      spInput.blur();
    }
  });

  /* debug deep-link: #search-<query> */
  if (location.hash.indexOf('#search-') === 0) {
    var spQ = decodeURIComponent(location.hash.slice(8));
    setTimeout(function () { spInput.value = spQ; spalShow(); spQuery(spQ); }, 500);
  }

})();

/* ============================================================
   HOMEPAGE LOGO ENTRANCE - "Tile Lay In".
   The hexes rest hidden under .at-logo--entrance (server-rendered
   on the homepage only). We compute a per-tile L->R stagger (by
   SVG x-centroid) and then add .is-playing to start it -- but we
   WAIT until the page has settled past the initial load storm
   (fonts ready + main thread idle) so the sweep doesn't compete
   with fonts/scripts/layout and stays smooth. Capped so the logo
   is never held hidden for long; fully guarded so it can never
   stay hidden. Locked design: .en-tile in
   _bsd-atelier-loader-concepts.html.
   ============================================================ */
(function () {
  'use strict';
  function revealStatic(svg) {                  // last-resort: show the logo, no animation
    try {
      Array.prototype.forEach.call(svg.querySelectorAll('.bath > *'), function (t) {
        t.style.opacity = '1'; t.style.transform = 'none';
      });
      var w = svg.querySelector('.wm');
      if (w) { w.style.opacity = '1'; w.style.clipPath = 'none'; }
    } catch (e) {}
  }
  try {
    // --- decide whether to welcome: play on a fresh visit (first page this tab
    // session) or a reload; stay silent when navigating back to home mid-browse.
    // Read the session flag BEFORE setting it; set it on EVERY page (incl. non-home)
    // so an in-session return to the homepage is recognised. If storage is blocked,
    // seen stays falsy and we default to welcoming.
    var SEEN_KEY = 'bsd_atelier_seen', seen;
    try { seen = sessionStorage.getItem(SEEN_KEY); sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    var isReload = false;
    try {
      var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (navEntry) isReload = navEntry.type === 'reload';
      else if (performance.navigation) isReload = performance.navigation.type === 1;
    } catch (e) {}

    var link = document.querySelector('.at-logo--entrance');
    if (!link) return;                          // not the homepage (flag already set above)
    var svg = link.querySelector('.at-logo-svg');
    if (!svg) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // CSS shows it static
    var tiles = Array.prototype.slice.call(svg.querySelectorAll('.bath > *'));
    if (!tiles.length) { revealStatic(svg); return; }
    if (!(isReload || !seen)) { revealStatic(svg); return; } // in-session return to home -> no re-welcome
    var wm = svg.querySelector('.wm');
    var SPAN = 0.55;                            // locked stagger span (s), L->R

    function play() {
      try {
        var cx = tiles.map(function (t) { var b = t.getBBox(); return b.x + b.width / 2; });
        var min = Math.min.apply(null, cx), max = Math.max.apply(null, cx), range = (max - min) || 1;
        tiles.forEach(function (t, i) {
          t.style.animationDelay = (((cx[i] - min) / range) * SPAN).toFixed(3) + 's';
          t.style.willChange = 'transform, opacity';
        });
        if (wm) wm.style.willChange = 'clip-path';
        link.classList.add('is-playing');       // delays already set -> clean staggered start
        setTimeout(function () {                 // drop compositor hints once it has finished (~1.6s)
          tiles.forEach(function (t) { t.style.willChange = 'auto'; });
          /* clear the inline hint (don't force 'auto') so the CSS will-change for
             the scroll-morph wipe takes over on the wordmark */
          if (wm) wm.style.willChange = '';
          /* release the entrance class so its animation-fill stops pinning the
             wordmark's clip-path - frees it for the mobile scroll-morph wipe */
          link.classList.remove('at-logo--entrance');
        }, 2200);
      } catch (e) { revealStatic(svg); }
    }

    // Start once the page is past the load storm: fonts settled, then a frame
    // when the main thread is idle. Hard-capped so we never stall the welcome.
    var fired = false;
    function trigger() { if (fired) return; fired = true; requestAnimationFrame(play); }
    var afterFonts = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(trigger, { timeout: 700 });
      else setTimeout(trigger, 80);
    };
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(afterFonts, afterFonts);
    } else {
      afterFonts();
    }
    setTimeout(trigger, 1500);                   // cap: play even if the idle signal never comes
  } catch (e) {
    var l = document.querySelector('.at-logo--entrance');
    if (l) { var s = l.querySelector('.at-logo-svg'); if (s) revealStatic(s); }
  }
})();


/* ============================================================
   ATELIER NAV V2 - custom mega-panel renderers (ported 2026-07-02).
   Pure HTML-string renderers + delegated interactions; no access
   to the header IIFE closure needed. The fork calls
   window.__ATHRender(key, d) and injects into #atMgCustom.
   Panel types: rail (Bathroom) / colours / brands.
   At port time this file merges into atelier-header.js and the
   styles in _harness-nav-v2.css merge into atelier-header.css.
   ============================================================ */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function thumbUrl(u, w) {
    if (!u) return '';
    if (!/^https?:/.test(u)) return u; /* local cutout file - no CDN params */
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }
  var chev = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  /* ---------------- BATHROOM: two-level rail + pane ---------------- */
  /* the rail item is a LINK to the department's parent collection (Chris
     2026-08-25) - it always looked clickable and did nothing. Hovering still
     swaps the pane; the click handler below covers the touch case. Falls back
     to the hub for a cat with no parent collection (Wastes & Traps). */
  function railItem(c, on) {
    return '<a class="at-rl-it' + (on ? ' on' : '') + '" data-ck="' + c.k + '" href="' + (c.coll || c.hub) + '">' +
      '<span class="at-rl-th">' + (c.railImg ? '<img src="' + thumbUrl(c.railImg, 180) + '" alt="" width="44" height="44" style="object-fit:' + (c.imageFit || 'cover') + ';object-position:' + (c.imagePosition || 'center') + '" loading="lazy">' : '') + '</span>' +
      '<span class="at-rl-tx"><b>' + esc(c.t) + '</b><small>' + c.n.toLocaleString() + ' products</small></span>' +
      chev + '</a>';
  }
  function linkHTML(l, i) {
    /* cutout thumbs float free (no box); links without a cutout keep an
       invisible spacer so labels stay column-aligned. Eager + CDN-resized:
       the intent warm-up below has usually cached these before a pane opens. */
    var u = thumbUrl(l.img, 140);
    var th = l.visual ? bsdMenuVisual(l) : l.cut
      ? '<span class="at-th at-th--cut"><img src="' + u + '" alt=""><img class="at-th-sh" src="' + u + '" alt="" aria-hidden="true"></span>'
      : (l.img
        ? '<span class="at-th"><img src="' + u + '" alt=""></span>'
        : '<span class="at-th at-th--cut at-th--none"></span>');
    return '<li style="--i:' + i + '"><a class="at-mg-l at-mg-l--v2' + (l.visual ? ' at-option' : (l.compact ? ' at-mg-l--compact' : '')) + '" href="' + l.h + '">' + (l.compact ? '' : th) +
      '<span class="at-lb"><span class="at-lt">' + esc(l.l) + '</span>' +
      (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') +
      '</span></a></li>';
  }
  /* feature slot (right column): 'prod' = Top-pick product card, 'tile' =
     editorial image tile - both reuse the production .at-mgp / .at-mg-tile look */
  var CDNF = 'https://cdn.shopify.com/s/files/1/0701/6261/2373/files/';
  function featHTML(f) {
    if (!f) return '';
    if (f.type === 'prod') {
      /* LIVE product wins over the baked values. Title, price, compare-at and
         image all drifted while they were hard-coded in the nav data - six of
         seven cards were advertising a price BELOW the real one, and the
         Showers card still carried the pre-rename product's image. ATFeat is
         emitted by snippets/atelier-nav-feat.liquid from all_products; the
         baked values remain as a fallback if a product goes unpublished. */
      var live = (window.ATFeat || {})[f.ph] || null;
      if (f.requireLive && !live) return '';
      var ft = live ? live.t : f.t;
      var fh = live && live.u ? live.u : f.h;
      var fp = live ? live.p : f.p;
      var fc = live ? live.c : f.c;
      var fi = live && live.i ? live.i : thumbUrl(CDNF + f.i, 480);
      var off = (fc && fp && fc > fp) ? Math.round((1 - fp / fc) * 100) : 0;
      return '<span class="at-mg-ft">Top pick</span>' +
        '<a class="at-mgp" href="' + fh + '">' +
        '<span class="at-mgp-im">' + (off ? '<span class="at-mgp-chip">&minus;' + off + '%</span>' : '') +
        '<img src="' + fi + '" alt="' + esc(ft) + '" loading="lazy"></span>' +
        '<span class="at-mgp-bd"><b>' + esc(ft) + '</b>' +
        '<span class="at-mgp-pr"><span class="at-now">$' + fp.toLocaleString() + '</span>' +
        (off ? '<span class="at-was">$' + fc.toLocaleString() + '</span>' : '') + '</span>' +
        '<span class="at-mgp-go">Shop now &rarr;</span></span></a>';
    }
    return '<span class="at-mg-ft">' + esc(f.k) + '</span>' +
      '<a class="at-mg-tile" href="' + f.h + '"><img src="' + thumbUrl(CDNF + f.i, 640) + '" alt="" loading="lazy">' +
      '<span>' + (f.tag ? '<i>' + esc(f.tag) + '</i>' : '') + '<b>' + esc(f.t) + '</b><span class="at-go">' + esc(f.go) + '</span></span></a>';
  }
  /* "Not sure what to pick?" hub banner - Chris-approved Option A (2026-07-13,
     picked from the 4-concept sandbox review): white gallery card + hairline,
     compass on cream, solid crimson pill CTA. Renders at the TOP of every pane
     so the hub entry is the first thing seen (the head's View-all also lands
     on the hub, but its label hides the guided finder behind it). */
  var GD_IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>';
  function guideHTML(hub, sub) {
    return hub
      ? '<a class="at-gd" href="' + hub + '"><i class="at-gd-ic">' + GD_IC + '</i>' +
        '<span class="at-gd-lb"><b>Not sure what to pick?</b><small>' + sub + '</small></span>' +
        '<span class="at-gd-btn">Start here</span></a>'
      : '';
  }
  function groupHTML(g, start) {
    var links = g.links.map(function (l, i) { return linkHTML(l, start + i); }).join('');
    if (g.visual) return '<details class="bsd-nav-options at-option-group"><summary><span>' + esc(g.h) + '</span><small>' + g.links.length + '</small><b aria-hidden="true">+</b></summary><ul>' + links + '</ul></details>';
    return '<div class="at-mg-g"><h5>' + esc(g.h) + '</h5><ul>' + links + '</ul></div>';
  }
  function paneHTML(c) {
    var i = 0;
    return '<div class="at-rl-head"><h4>' + esc(c.t) + '</h4><a class="at-rl-all" href="' + (c.coll || c.hub) + '">' + esc(window.BSDNav.text('view_all',{category:c.t})) + ' →</a></div>' +
      '<div class="at-rl-groups">' + c.groups.map(function (g) { var h=groupHTML(g,i);i+=g.links.length;return h; }).join('') + '</div>' +
      window.__ATHFinishHTML(c) + window.BSDNav.range(c) + window.__ATHBrandHTML(c.k || c.brandKey);
  }
  function railHTML(d) {
    return '<div class="at-wrap at-rl">' +
      '<div class="at-rl-rail" role="tablist" aria-label="Bathroom categories">' +
      d.cats.map(function (c, i) { return railItem(c, i === 0); }).join('') +
      '</div>' +
      '<div class="at-rl-pane" id="atRlPane" data-ck="' + d.cats[0].k + '">' + paneHTML(d.cats[0]) + '</div>' +
      '</div>';
  }
  /* sliding red ink accent: one bar per rail that glides to the selected
     category (approved micro-interaction; selection follows hover here) */
  function railInk(rail, btn) {
    if (!rail || !btn) return;
    var ink = rail.querySelector('.at-rl-ink');
    if (!ink) {
      ink = document.createElement('span');
      ink.className = 'at-rl-ink';
      rail.appendChild(ink);
    }
    ink.style.transform = 'translateY(' + (btn.offsetTop + (btn.offsetHeight - 26) / 2) + 'px)';
    ink.classList.add('on');
  }
  function railSelect(btn) {
    var pane = document.getElementById('atRlPane');
    if (!pane || pane.dataset.ck === btn.dataset.ck) return;
    var d = window.NAV2.mega.bathroom;
    var cat = null;
    for (var i = 0; i < d.cats.length; i++) if (d.cats[i].k === btn.dataset.ck) cat = d.cats[i];
    if (!cat) return;
    var rail = btn.parentNode;
    Array.prototype.slice.call(rail.querySelectorAll('.at-rl-it')).forEach(function (b) {
      b.classList.toggle('on', b === btn);
    });
    railInk(rail, btn);
    pane.dataset.ck = cat.k;
    pane.innerHTML = paneHTML(cat);
  }

  /* ---------------- KITCHEN / LAUNDRY: standard layout, dict links w/ thumbs.
     Mirrors the production .at-mg-grid (links | preview | feature) + a quick
     strip row, but renders the v2 dict format so links carry thumbnails. */
  function stdHTML(d) {
    var i = 0;
    return '<div class="at-wrap bsd-nav-standard"><div class="at-rl-head"><h4>' + esc(d.t) + '</h4><a class="at-rl-all" href="' + d.all + '">' + esc(window.BSDNav.text('view_all',{category:d.t})) + ' →</a></div>' +
      '<div class="bsd-nav-standard-body' + (d.range ? ' has-range' : '') + '"><div class="at-v2-links">' + d.groups.map(function(g){var h=groupHTML(g,i);i+=g.links.length;return h;}).join('') + '</div>' +
      (d.range ? '<aside>' + window.BSDNav.range(d) + '</aside>' : '') + '</div>' +
      window.__ATHFinishHTML(d) + window.__ATHBrandHTML(d.brandKey) + '</div>';
  }

  /* ---------------- COLOURS: finish tiles ---------------- */
  function coloursHTML(d) {
    return '<div class="at-wrap at-clp">' +
      '<div class="at-clp-side">' +
        '<span class="at-mg-ft at-finish-heading">Shop by finish</span>' +
        '<h4>One finish,<br>every piece.</h4>' +
        '<p>Each collection gathers tapware, showers, wastes and accessories in a single finish - so the whole room matches.</p>' +
        '<a class="at-clp-find" href="/pages/colours">Find your finish &rarr;</a>' +
      '</div>' +
      '<div class="at-clp-grid">' +
      d.finishes.map(function (f, i) {
        return '<a class="at-clp-t" style="--i:' + i + '" href="' + f.h + '">' +
          '<i class="at-fsw--' + f.sw + '"></i><b>' + esc(f.l) + '</b>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a>';
      }).join('') +
      '</div></div>';
  }

  /* ---------------- BRANDS: logo tiles ---------------- */
  /* true-vector logo lookup: window.ATBrandSVG (emitted by atelier-header.liquid,
     keys = handleized brand name) - crisp at any size, preferred over the
     raster nav-data URLs */
  function brandSvg(name) {
    var m = window.ATBrandSVG || {};
    return m[(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')] || '';
  }
  function brandsHTML(d) {
    var f = d.featured, fsvg = f ? brandSvg(f.name) : '';
    return '<div class="at-wrap at-brp">' +
      (f ? '<a class="at-brp-feat" href="' + f.h + '">' +
        '<span class="at-mg-ft">Featured brand</span>' +
        '<span class="at-brp-fim' + (fsvg ? ' at-brp-fim--svg' : '') + '">' +
          (fsvg ? '<img src="' + fsvg + '" alt="' + esc(f.name) + '">'
                : f.logo ? '<img src="' + thumbUrl(f.logo, 480) + '" alt="' + esc(f.name) + '">' : '') + '</span>' +
        '<p>' + esc(f.d || 'Designed. Considered. Crafted. Refined.') + '</p>' +
        '<span class="at-go">Explore ' + esc(f.name) + ' &rarr;</span></a>' : '') +
      '<div class="at-brp-main">' +
        '<div class="at-brp-grid">' +
        d.brands.map(function (b, i) {
          /* SVG wordmarks sit contained with breathing room; the raster
             brands metaobject images FILL the tile as before (see the
             brand-logo-fill convention) - caption below either way */
          var sv = brandSvg(b.name);
          var im = sv ? '<img src="' + sv + '" alt="" loading="lazy">'
                 : b.logo ? '<img src="' + thumbUrl(b.logo, 320) + '" alt="" loading="lazy">'
                 : '<b class="at-brp-nm">' + esc(b.name) + '</b>';
          return '<a class="at-brp-t" style="--i:' + i + '" href="' + b.h + '">' +
            '<span class="at-brp-im' + (sv ? ' at-brp-im--svg' : '') + '">' + im + '</span>' +
            '<span class="at-brp-cap"><b>' + (sv || b.logo ? esc(b.name) : '') + '</b><small>' + b.n.toLocaleString() + '</small></span></a>';
        }).join('') +
        '</div>' +
        '<a class="at-brp-all" href="' + d.all + '">All brands &rarr;</a>' +
      '</div></div>';
  }

  window.__ATHRender = function (key, d) {
    if (d.ptype === 'rail') return railHTML(d);
    if (d.ptype === 'std') return stdHTML(d);
    if (d.ptype === 'colours') return coloursHTML(d);
    if (d.ptype === 'brands') return brandsHTML(d);
    return '';
  };
  window.__ATHInit = function (key, d, cEl) {
    /* rail panels: position the ink on the selected category once laid out */
    if (d && d.ptype === 'rail' && cEl) {
      requestAnimationFrame(function () {
        var rail = cEl.querySelector('.at-rl-rail');
        if (rail) railInk(rail, rail.querySelector('.at-rl-it.on'));
      });
    }
  };
  window.__ATHFeat = featHTML; /* reused by the drawer right pane */

  /* rail interactions: hover or click a rail item swaps the pane; hovering a
     link with a curated preview (data-pv) swaps the pane hero image */
  document.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('.at-rl-it');
    if (b) railSelect(b);
  });
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('.at-rl-it');
    if (b) railSelect(b);
  });
  /* harness deep-link: #mega-bathroom&cat=<key> selects a rail category after
     the panel's own 400ms deep-link open (used for headless verification) */
  var catHash = location.hash.match(/&cat=(\w+)/);
  if (catHash) {
    setTimeout(function () {
      var b = document.querySelector('.at-rl-it[data-ck="' + catHash[1] + '"]');
      if (b) railSelect(b);
    }, 900);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.at-rl-it');
    if (!b) return;
    /* no-hover (touch) devices cannot preview a pane by hovering, so the FIRST
       tap selects the category and only a second tap on the already-selected
       item follows the link. Pointer devices navigate on the first click. */
    if (!b.classList.contains('on') && window.matchMedia &&
        window.matchMedia('(hover: none)').matches) {
      e.preventDefault();
      railSelect(b);
      return;
    }
    railSelect(b);
  });

  /* ---- panel-image warm-up v2 (2026-07-17): starts on first nav INTENT, not
     on page load. The old always-on warm-up cost every cold landing ~1MB /
     ~260 requests even when the visitor never opened the nav (measured in the
     business-case Lighthouse audit). pointerover/focusin/touchstart on the nav
     row or a drawer trigger fires 150-400ms before a pane can open, and the
     pane being approached is queued FIRST, so its images are normally cached
     by open time. Stragglers fade in via fadePending below instead of popping.
     Data-saver / 2G connections skip the warm-up entirely (pane imgs just
     load on open). Trickle pacing unchanged (6 per 120ms tick). */
  function preloadPanelImages(firstKey) {
    try {
      var nav = window.NAV2;
      if (!nav) return;
      var urls = [], seen = {};
      function add(u, w) {
        if (!u) return;
        var full = thumbUrl(u, w || 140);
        if (seen[full]) return;
        seen[full] = 1;
        urls.push(full);
      }
      /* push a URL that is ALREADY sized - running it through add() would
         append a second width param and warm a different file than the one
         the card renders */
      function addExact(u) {
        if (!u || seen[u]) return;
        seen[u] = 1;
        urls.push(u);
      }
      function feat(f) {
        if (!f) return;
        /* a Top pick card renders the LIVE product image from ATFeat, so warm
           THAT url. Warming the baked CDNF one left the card fetching its
           image cold on open - the warm-up was preloading a file the card no
           longer uses. ATFeat's url already carries width=480 from liquid. */
        if (f.type === 'prod') {
          var live = (window.ATFeat || {})[f.ph];
          if (live && live.i) { addExact(live.i); return; }
        }
        /* widths must MATCH featHTML's renders (prod card 480 / tile 640) -
           a mismatched warm width means the same file downloads twice */
        if (f.i) add(CDNF + f.i, f.type === 'prod' ? 480 : 640);
      }
      function dept(k) {
        return function () {
          var d = nav.mega[k];
          if (!d) return;
          add(d.img, 640);
          feat(d.feat);
          d.groups.forEach(function (g) { g.links.forEach(function (l) { add(l.img); }); });
        };
      }
      var builders = {
        bathroom: function () {
          (nav.mega.bathroom.cats || []).forEach(function (c) {
            add(c.railImg, 120);
            add(c.railImg, 640);
            feat(c.feat);
            c.groups.forEach(function (g) { g.links.forEach(function (l) { add(l.img); }); });
          });
        },
        kitchen: dept('kitchen'),
        laundry: dept('laundry'),
        tapware: dept('tapware'),
        brands: function () {
          (nav.mega.brands.brands || []).forEach(function (b) {
            var sv = brandSvg(b.name);
            if (sv) { urls.push(sv); } else { add(b.logo, 320); }
          });
          if (nav.mega.brands.featured) {
            var fsv = brandSvg(nav.mega.brands.featured.name);
            if (fsv) { urls.push(fsv); } else { add(nav.mega.brands.featured.logo, 480); }
          }
        }
      };
      var order = ['bathroom', 'kitchen', 'laundry', 'tapware', 'brands'];
      if (firstKey && builders[firstKey]) builders[firstKey](); /* seen-map dedupes the ordered pass */
      order.forEach(function (k) { builders[k](); });
      var i = 0;
      (function next() {
        for (var n = 0; n < 6 && i < urls.length; n++, i++) {
          (new Image()).src = urls[i];
        }
        if (i < urls.length) setTimeout(next, 120);
      })();
    } catch (e) { /* warm-up is best-effort only */ }
  }
  var warmed = false;
  function warmOnIntent(e) {
    if (warmed) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.at-nv, #atBurger, #atNavAllCats, .at-mega, .at-xdrawer, .at-mdrawer')) return;
    warmed = true;
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return;
    var nv = t.closest('.at-nv[data-mega]');
    preloadPanelImages(nv ? nv.dataset.mega : null);
  }
  ['pointerover', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, warmOnIntent, { capture: true, passive: true });
  });

  /* late-arrival fade: a pane/drawer img that isn't already cached when its
     markup lands gets .at-imgwait until it loads - CSS fades it in. Cached
     imgs are complete at insert time, never get the class, and render
     instantly (the no-visible-mechanism bar). Silhouette shadows (.at-th-sh)
     are excluded - their opacity belongs to the approved hover
     micro-interaction and must not gain a competing transition. */
  function fadePending(root) {
    if (!root || root.nodeType !== 1) return;
    var imgs = root.tagName === 'IMG' ? [root] : root.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.complete) return;
      if (im.className.indexOf('at-th-sh') > -1 || im.className.indexOf('at-imgfade') > -1) return;
      im.classList.add('at-imgfade', 'at-imgwait');
      function done() { im.classList.remove('at-imgwait'); }
      im.addEventListener('load', done, { once: true });
      im.addEventListener('error', done, { once: true });
    });
  }
  ['at-mega', 'at-xdrawer', 'at-mdrawer'].forEach(function (cls) {
    var el = document.querySelector('.' + cls);
    if (!el) return;
    fadePending(el);
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        for (var n = 0; n < muts[m].addedNodes.length; n++) fadePending(muts[m].addedNodes[n]);
      }
    }).observe(el, { childList: true, subtree: true });
  });
})();








(function () {
  var panel = document.querySelector('.at-mega'), content = panel && panel.querySelector('.at-mg-custom');
  if (!content) return;
  var cue = document.createElement('div');
  cue.className = 'bsd-nav-scroll-cue';
  cue.textContent = window.BSDNav.text('scroll_more') + ' ↓';
  panel.appendChild(cue);
  function sync() { panel.classList.toggle('bsd-nav-has-more', content.scrollHeight - content.scrollTop > content.clientHeight + 12); }
  content.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync,{passive:true});
  new MutationObserver(function(){requestAnimationFrame(sync);}).observe(content,{childList:true,subtree:true});
  new ResizeObserver(sync).observe(content);
}());

